import axios from "axios";
import React, { useEffect, useRef, useState } from "react";
import { api } from "../utils/Api";
import {
	Typography,
	Flex,
	DatePicker,
	Table,
	Button,
	Modal,
	Image,
	Statistic,
	Row,
	Col,
	Select,
	notification,
} from "antd";
import Layout from "../layout/Layout";
import { CustomSpinner } from "../utils/CustomComponents";
import dayjs from "dayjs";
import {
	FileImageOutlined,
	CheckCircleOutlined,
	FilePdfOutlined,
	DeleteFilled,
	EditFilled,
} from "@ant-design/icons";
import { CSVLink } from "react-csv";
const { Text, Title } = Typography;

const jobStatusOptions = [
	{
		value: "Pouring",
		label: "Pouring",
	},
	{
		value: "A/R",
		label: "A/R",
	},
];

const WebLogisticsDashboard = ({ history }) => {
	const [loading, setLoading] = useState(true);
	const [loadingTable, setLoadingTable] = useState(false);
	const [loadingButton, setLoadingButton] = useState(false);
	const [sandList, setSandList] = useState([]);
	const [gravelList, setGravelList] = useState([]);
	const [peaGravelList, setPeaGravelList] = useState([]);
	const [calicheList, setCalicheList] = useState([]);
	const [crushed34List, setCrushed34List] = useState([]);
	const [limestoneList, setLimestoneList] = useState([]);
	const [date, setDate] = useState(dayjs());
	const [evidence, setEvidence] = useState(null);
	const [openEvidenceModal, setOpenEvidenceModal] = useState(false);
	const [detailedData, setDetailedData] = useState([]);
	const [clients, setClients] = useState([]);
	const [mines, setMines] = useState([]);
	const [dataExport, setDataExport] = useState([]);
	const [client, setClient] = useState("All");
	const [mine, setMine] = useState("All");
	const refDownload = useRef();
	const [apiNotification, contextHolder] = notification.useNotification();

	const openNotification = (type, message, description) => {
		apiNotification[type]({
			message: message,
			description: description,
		});
	};

	/**
	 ** Options header (columns)
	 */
	const columns = [
		{
			title: "Mine",
			dataIndex: "mine",
			key: "mine",
			render: (value) => {
				return <Text strong>{value}</Text>;
			},
		},
		{
			title: "Truck",
			dataIndex: "truck",
			key: "truck",
			render: (value) => {
				return <Text>{value}</Text>;
			},
		},
		{
			title: "Driver",
			dataIndex: "driver",
			key: "driver",
			render: (value) => {
				return <Text>{value}</Text>;
			},
		},
		{
			title: "Quantity (ton)",
			dataIndex: "quantity",
			key: "quantity",
			render: (value) => {
				return (
					<Statistic
						title=""
						value={value}
						precision={2}
						valueStyle={{ fontSize: 14 }}
					/>
				);
			},
		},
		{
			title: "Ticket",
			dataIndex: "ticket",
			key: "ticket",
			render: (value) => {
				return <Text>{value}</Text>;
			},
		},
		{
			title: "Material",
			dataIndex: "material",
			key: "material",
			render: (value) => {
				return <Text>{value}</Text>;
			},
		},
		{
			title: "Client",
			dataIndex: "client",
			key: "client",
			render: (value) => {
				return <Text>{value}</Text>;
			},
		},
		{
			title: "Started Date",
			dataIndex: "startedDate",
			key: "startedDate",
			render: (value) => {
				return <Text>{value}</Text>;
			},
		},
		{
			title: "Received Date",
			dataIndex: "receivedDate",
			key: "receivedDate",
			render: (value) => {
				return <Text>{value}</Text>;
			},
		},
		{
			title: "Duration",
			dataIndex: "duration",
			key: "duration",
			render: (value) => {
				return <Text>{value}</Text>;
			},
		},
		{
			title: "",
			dataIndex: "actions",
			width: 100,
			render: (_, record) => {
				return (
					<Flex gap={"small"}>
						{!record.received && (
							<Button
								type="primary"
								style={{ backgroundColor: "green" }}
								icon={<CheckCircleOutlined twoToneColor={"white"} />}
								onClick={(e) => updateRecord(record.id)}
								loading={loadingButton}
								disabled={loadingButton}
							>
								End Trip
							</Button>
						)}

						{record.evidence && (
							<Button
								type="primary"
								icon={<FileImageOutlined twoToneColor={"white"} />}
								onClick={(e) => handleEvidenceOpen(record.evidence)}
								loading={loadingButton}
								disabled={loadingButton}
							>
								Evidence
							</Button>
						)}
						{record.receivedDate !== "-" && (
							<Button
								type="primary"
								style={{ backgroundColor: "red" }}
								icon={<FilePdfOutlined twoToneColor={"white"} />}
								onClick={(e) => history.push(`/logisticspdf/${record.id}`)}
								loading={loadingButton}
								disabled={loadingButton}
							>
								PDF
							</Button>
						)}
						{(localStorage.getItem("email") === "eliud@gmail.com" ||
							localStorage.getItem("email") === "ec@57concrete.com" ||
							localStorage.getItem("email") === "jip@57concrete.com" ||
							localStorage.getItem("email") === "ac@57concrete.com" ||
							localStorage.getItem("email") === "jl@57concrete.com" ||
							localStorage.getItem("email") === "pc@57concrete.com" ||
							localStorage.getItem("email") === "scale@filegonia.com" ||
							localStorage.getItem("email") === "reyesss22@icloud.com" ||
							localStorage.getItem("email") === "vm@57concrete.com") && (
							<Button
								type="primary"
								style={{ backgroundColor: "red" }}
								icon={<DeleteFilled twoToneColor={"white"} />}
								onClick={(e) => deleteRecord(record.id)}
								loading={loadingButton}
								disabled={loadingButton}
							>
								Delete
							</Button>
						)}
						{(localStorage.getItem("email") === "eliud@gmail.com" ||
							localStorage.getItem("email") === "ec@57concrete.com" ||
							localStorage.getItem("email") === "vm@57concrete.com" ||
							localStorage.getItem("email") === "ac@57concrete.com" ||
							localStorage.getItem("email") === "jl@57concrete.com" ||
							localStorage.getItem("email") === "ar@57concrete.com" ||
							localStorage.getItem("email") === "cb@57concrete.com" ||
							localStorage.getItem("email") === "pc@57concrete.com" ||
							localStorage.getItem("email") === "scale@filegonia.com" ||
							localStorage.getItem("email") === "reyesss22@icloud.com" ||
							localStorage.getItem("email") === "office@castlereadymix.com" ||
							(localStorage.getItem("email") === "jip@57concrete.com" &&
								record.client === "San Benito")) && (
							<Button
								type="primary"
								icon={<EditFilled twoToneColor={"white"} />}
								onClick={(e) => history.push(`/logisticstrip/${record.id}`)}
								loading={loadingButton}
								disabled={loadingButton}
							>
								Edit
							</Button>
						)}
					</Flex>
				);
			},
		},
	];

	const columnsCSV = [
		{
			label: "ID",
			key: "id",
		},
		{
			label: "Quantity",
			key: "quantity",
		},
		{
			label: "Material",
			key: "material",
		},
		{
			label: "Client",
			key: "client",
		},
		{
			label: "Mine",
			key: "mine",
		},
		{
			label: "Status",
			key: "status",
		},
	];

	useEffect(() => {
		getValues();
	}, []);

	const getValues = async () => {
		await Promise.all([getClients(), getMines()]).then(() => {
			let dateString = `${date.year()}-${date.month() + 1}-${date.date()}`;
			getTripList(dateString, client, mine);
		});
	};

	const getClients = async () => {
		setLoading(true);
		const token = localStorage.getItem("token");
		axios.defaults.headers.common = { Authorization: `Bearer ${token}` };
		const url = api + `/logistics/client/list/jap`;

		try {
			const { data } = await axios.get(url);
			let list = [
				{
					value: "All",
					label: "All",
				},
			];

			if (data.success) {
				data.payload.map((item) => {
					list.push({
						value: item._id,
						label: item.name,
					});
				});
				setClients(list);
			} else {
				openNotification("error", "Error", data.message);
				setLoading(false);
			}
		} catch (err) {
			console.error(err.message);
			openNotification("error", "Error", err.message);
			return null;
		}
	};

	const getMines = async () => {
		setLoading(true);
		const token = localStorage.getItem("token");
		axios.defaults.headers.common = { Authorization: `Bearer ${token}` };
		const url = api + `/logistics/mine/list/jap`;

		try {
			const { data } = await axios.get(url);
			let list = [
				{
					value: "All",
					label: "All",
				},
			];

			if (data.success) {
				data.payload.map((item) => {
					list.push({
						value: item._id,
						label: item.name,
					});
				});
				setMines(list);
			} else {
				openNotification("error", "Error", data.message);
				setLoading(false);
			}
		} catch (err) {
			console.error(err.message);
			openNotification("error", "Error", err.message);
			return null;
		}
	};

	const getTripList = async (date, client, mine) => {
		setLoading(true);
		const url =
			api + `/logisticstrip/list?date=${date}&client=${client}&mine=${mine}`;
		const token = localStorage.getItem("token");
		axios.defaults.headers.common = { Authorization: `Bearer ${token}` };

		try {
			const { data } = await axios.get(url);

			let list = [];
			data.map((item, index) => {
				let duration = "0";
				if (item.startedDate && item.receivedDate) {
					var diffMs = new Date(item.receivedDate) - new Date(item.startedDate);
					var diffHrs = Math.floor((diffMs % 86400000) / 3600000); // hours
					var diffMins = Math.round(((diffMs % 86400000) % 3600000) / 60000); // minutes
					duration = `${diffHrs} hours, ${diffMins} minutes`;
				}

				list.push({
					key: index,
					id: item._id,
					mine: item.mineId.name,
					material: item.materialId.name,
					quantity: item.quantity,
					ticket: item.ticket,
					client: item.clientId.name,
					driver: item.driver.name,
					truck: item.truck.number,
					evidence: item.evidence || null,
					startedDate: item.startedDate
						? `${dayjs(item.startedDate)
								.toDate()
								.toLocaleDateString()} - ${dayjs(item.startedDate)
								.toDate()
								.toLocaleTimeString([], { timeStyle: "short" })}`
						: "-",
					receivedDate: item.receivedDate
						? `${dayjs(item.receivedDate)
								.toDate()
								.toLocaleDateString()} - ${dayjs(item.receivedDate)
								.toDate()
								.toLocaleTimeString([], { timeStyle: "short" })}`
						: "-",
					duration: duration,
					received: item.received,
					jobStatus: item.jobStatus || "Pouring",
				});
			});

			let dupes = {};
			list.forEach((item, index) => {
				dupes[item.ticket] = dupes[item.ticket] || [];
				dupes[item.ticket].push(index);
			});

			Object.entries(dupes).forEach((item, index) => {
				if (item[1].length > 1) {
					item[1].map((val) => (list[val].duplicated = true));
				}
			});

			//SAND
			//SAND - MISSION
			let sandListMM = list.filter(
				(trip) =>
					(trip.material === "Sand" || trip.material === "Concrete Sand") &&
					trip.client === "Mission" &&
					trip.mine === "Mile 4",
			);
			let sandListMT = list.filter(
				(trip) =>
					(trip.material === "Sand" || trip.material === "Concrete Sand") &&
					trip.client === "Mission" &&
					trip.mine === "Texan",
			);
			let sandListMRL = list.filter(
				(trip) =>
					(trip.material === "Sand" || trip.material === "Concrete Sand") &&
					trip.client === "Mission" &&
					trip.mine === "Rojo Limestone",
			);
			//SAND - SAN BENITO
			let sandListSBM = list.filter(
				(trip) =>
					(trip.material === "Sand" || trip.material === "Concrete Sand") &&
					trip.client === "San Benito" &&
					trip.mine === "Mile 4",
			);
			let sandListSBT = list.filter(
				(trip) =>
					(trip.material === "Sand" || trip.material === "Concrete Sand") &&
					trip.client === "San Benito" &&
					trip.mine === "Texan",
			);
			let sandListSBRL = list.filter(
				(trip) =>
					(trip.material === "Sand" || trip.material === "Concrete Sand") &&
					trip.client === "San Benito" &&
					trip.mine === "Rojo Limestone",
			);
			//SAND - LAREDO
			let sandListLM = list.filter(
				(trip) =>
					(trip.material === "Sand" || trip.material === "Concrete Sand") &&
					trip.client === "Laredo" &&
					trip.mine === "Mile 4",
			);
			let sandListLT = list.filter(
				(trip) =>
					(trip.material === "Sand" || trip.material === "Concrete Sand") &&
					trip.client === "Laredo" &&
					trip.mine === "Texan",
			);
			let sandListLRL = list.filter(
				(trip) =>
					(trip.material === "Sand" || trip.material === "Concrete Sand") &&
					trip.client === "Laredo" &&
					trip.mine === "Rojo Limestone",
			);
			//SAND - BROWNSVILLE
			let sandListBM = list.filter(
				(trip) =>
					(trip.material === "Sand" || trip.material === "Concrete Sand") &&
					trip.client === "Brownsville" &&
					trip.mine === "Mile 4",
			);
			let sandListBT = list.filter(
				(trip) =>
					(trip.material === "Sand" || trip.material === "Concrete Sand") &&
					trip.client === "Brownsville" &&
					trip.mine === "Texan",
			);
			let sandListBRL = list.filter(
				(trip) =>
					(trip.material === "Sand" || trip.material === "Concrete Sand") &&
					trip.client === "Brownsville" &&
					trip.mine === "Rojo Limestone",
			);
			//SAND - VALLEY WIDE
			let sandListVWM = list.filter(
				(trip) =>
					(trip.material === "Sand" || trip.material === "Concrete Sand") &&
					trip.client === "Valley Wide" &&
					trip.mine === "Mile 4",
			);
			let sandListVWT = list.filter(
				(trip) =>
					(trip.material === "Sand" || trip.material === "Concrete Sand") &&
					trip.client === "Valley Wide" &&
					trip.mine === "Texan",
			);
			let sandListVWRL = list.filter(
				(trip) =>
					(trip.material === "Sand" || trip.material === "Concrete Sand") &&
					trip.client === "Valley Wide" &&
					trip.mine === "Rojo Limestone",
			);
			//GRAVEL
			//GRAVEL - MISSION
			let gravelListMM = list.filter(
				(trip) =>
					(trip.material === "Gravel" || trip.material === '1" Gravel') &&
					trip.client === "Mission" &&
					trip.mine === "Mile 4",
			);
			let gravelListMT = list.filter(
				(trip) =>
					(trip.material === "Gravel" || trip.material === '1" Gravel') &&
					trip.client === "Mission" &&
					trip.mine === "Texan",
			);
			let gravelListMRL = list.filter(
				(trip) =>
					(trip.material === "Gravel" || trip.material === '1" Gravel') &&
					trip.client === "Mission" &&
					trip.mine === "Rojo Limestone",
			);
			//GRAVEL - SAN BENITO
			let gravelListSBM = list.filter(
				(trip) =>
					(trip.material === "Gravel" || trip.material === '1" Gravel') &&
					trip.client === "San Benito" &&
					trip.mine === "Mile 4",
			);
			let gravelListSBT = list.filter(
				(trip) =>
					(trip.material === "Gravel" || trip.material === '1" Gravel') &&
					trip.client === "San Benito" &&
					trip.mine === "Texan",
			);
			let gravelListSBRL = list.filter(
				(trip) =>
					(trip.material === "Gravel" || trip.material === '1" Gravel') &&
					trip.client === "San Benito" &&
					trip.mine === "Rojo Limestone",
			);
			//GRAVEL - LAREDO
			let gravelListLM = list.filter(
				(trip) =>
					(trip.material === "Gravel" || trip.material === '1" Gravel') &&
					trip.client === "Laredo" &&
					trip.mine === "Mile 4",
			);
			let gravelListLT = list.filter(
				(trip) =>
					(trip.material === "Gravel" || trip.material === '1" Gravel') &&
					trip.client === "Laredo" &&
					trip.mine === "Texan",
			);
			let gravelListLRL = list.filter(
				(trip) =>
					(trip.material === "Gravel" || trip.material === '1" Gravel') &&
					trip.client === "Laredo" &&
					trip.mine === "Rojo Limestone",
			);
			//GRAVEL - BROWNSVILLE
			let gravelListBM = list.filter(
				(trip) =>
					(trip.material === "Gravel" || trip.material === '1" Gravel') &&
					trip.client === "Brownsville" &&
					trip.mine === "Mile 4",
			);
			let gravelListBT = list.filter(
				(trip) =>
					(trip.material === "Gravel" || trip.material === '1" Gravel') &&
					trip.client === "Brownsville" &&
					trip.mine === "Texan",
			);
			let gravelListBRL = list.filter(
				(trip) =>
					(trip.material === "Gravel" || trip.material === '1" Gravel') &&
					trip.client === "Brownsville" &&
					trip.mine === "Rojo Limestone",
			);
			//GRAVEL - VALLEY WIDE
			let gravelListVWM = list.filter(
				(trip) =>
					(trip.material === "Gravel" || trip.material === '1" Gravel') &&
					trip.client === "Valley Wide" &&
					trip.mine === "Mile 4",
			);
			let gravelListVWT = list.filter(
				(trip) =>
					(trip.material === "Gravel" || trip.material === '1" Gravel') &&
					trip.client === "Valley Wide" &&
					trip.mine === "Texan",
			);
			let gravelListVWRL = list.filter(
				(trip) =>
					(trip.material === "Gravel" || trip.material === '1" Gravel') &&
					trip.client === "Valley Wide" &&
					trip.mine === "Rojo Limestone",
			);
			//PEA GRAVEL
			//PEA GRAVEL - MISSION
			let peaGravelListMM = list.filter(
				(trip) =>
					trip.material === "Pea Gravel" &&
					trip.client === "Mission" &&
					trip.mine === "Mile 4",
			);
			let peaGravelListMT = list.filter(
				(trip) =>
					trip.material === "Pea Gravel" &&
					trip.client === "Mission" &&
					trip.mine === "Texan",
			);
			let peaGravelListMRL = list.filter(
				(trip) =>
					trip.material === "Pea Gravel" &&
					trip.client === "Mission" &&
					trip.mine === "Rojo Limestone",
			);
			//PEA GRAVEL - SAN BENITO
			let peaGravelListSBM = list.filter(
				(trip) =>
					trip.material === "Pea Gravel" &&
					trip.client === "San Benito" &&
					trip.mine === "Mile 4",
			);
			let peaGravelListSBT = list.filter(
				(trip) =>
					trip.material === "Pea Gravel" &&
					trip.client === "San Benito" &&
					trip.mine === "Texan",
			);
			let peaGravelListSBRL = list.filter(
				(trip) =>
					trip.material === "Pea Gravel" &&
					trip.client === "San Benito" &&
					trip.mine === "Rojo Limestone",
			);
			//PEA GRAVEL - LAREDO
			let peaGravelListLM = list.filter(
				(trip) =>
					trip.material === "Pea Gravel" &&
					trip.client === "Laredo" &&
					trip.mine === "Mile 4",
			);
			let peaGravelListLT = list.filter(
				(trip) =>
					trip.material === "Pea Gravel" &&
					trip.client === "Laredo" &&
					trip.mine === "Texan",
			);
			let peaGravelListLRL = list.filter(
				(trip) =>
					trip.material === "Pea Gravel" &&
					trip.client === "Laredo" &&
					trip.mine === "Rojo Limestone",
			);
			//PEA GRAVEL - BROWNSVILLE
			let peaGravelListBM = list.filter(
				(trip) =>
					trip.material === "Pea Gravel" &&
					trip.client === "Brownsville" &&
					trip.mine === "Mile 4",
			);
			let peaGravelListBT = list.filter(
				(trip) =>
					trip.material === "Pea Gravel" &&
					trip.client === "Brownsville" &&
					trip.mine === "Texan",
			);
			let peaGravelListBRL = list.filter(
				(trip) =>
					trip.material === "Pea Gravel" &&
					trip.client === "Brownsville" &&
					trip.mine === "Rojo Limestone",
			);
			//PEA GRAVEL - VALLEY WIDE
			let peaGravelListVWM = list.filter(
				(trip) =>
					trip.material === "Pea Gravel" &&
					trip.client === "Valley Wide" &&
					trip.mine === "Mile 4",
			);
			let peaGravelListVWT = list.filter(
				(trip) =>
					trip.material === "Pea Gravel" &&
					trip.client === "Valley Wide" &&
					trip.mine === "Texan",
			);
			let peaGravelListVWRL = list.filter(
				(trip) =>
					trip.material === "Pea Gravel" &&
					trip.client === "Valley Wide" &&
					trip.mine === "Rojo Limestone",
			);
			//CALICHE
			//CALICHE - MISSION
			let calicheListMM = list.filter(
				(trip) =>
					trip.material === "Caliche" &&
					trip.client === "Mission" &&
					trip.mine === "Mile 4",
			);
			let calicheListMT = list.filter(
				(trip) =>
					trip.material === "Caliche" &&
					trip.client === "Mission" &&
					trip.mine === "Texan",
			);
			let calicheListMRL = list.filter(
				(trip) =>
					trip.material === "Caliche" &&
					trip.client === "Mission" &&
					trip.mine === "Rojo Limestone",
			);
			//CALICHE - SAN BENITO
			let calicheListSBM = list.filter(
				(trip) =>
					trip.material === "Caliche" &&
					trip.client === "San Benito" &&
					trip.mine === "Mile 4",
			);
			let calicheListSBT = list.filter(
				(trip) =>
					trip.material === "Caliche" &&
					trip.client === "San Benito" &&
					trip.mine === "Texan",
			);
			let calicheListSBRL = list.filter(
				(trip) =>
					trip.material === "Caliche" &&
					trip.client === "San Benito" &&
					trip.mine === "Rojo Limestone",
			);
			//CALICHE - LAREDO
			let calicheListLM = list.filter(
				(trip) =>
					trip.material === "Caliche" &&
					trip.client === "Laredo" &&
					trip.mine === "Mile 4",
			);
			let calicheListLT = list.filter(
				(trip) =>
					trip.material === "Caliche" &&
					trip.client === "Laredo" &&
					trip.mine === "Texan",
			);
			let calicheListLRL = list.filter(
				(trip) =>
					trip.material === "Caliche" &&
					trip.client === "Laredo" &&
					trip.mine === "Rojo Limestone",
			);
			//CALICHE - BROWNSVILLE
			let calicheListBM = list.filter(
				(trip) =>
					trip.material === "Caliche" &&
					trip.client === "Brownsville" &&
					trip.mine === "Mile 4",
			);
			let calicheListBT = list.filter(
				(trip) =>
					trip.material === "Caliche" &&
					trip.client === "Brownsville" &&
					trip.mine === "Texan",
			);
			let calicheListBRL = list.filter(
				(trip) =>
					trip.material === "Caliche" &&
					trip.client === "Brownsville" &&
					trip.mine === "Rojo Limestone",
			);
			//CALICHE - VALLEY WIDE
			let calicheListVWM = list.filter(
				(trip) =>
					trip.material === "Caliche" &&
					trip.client === "Valley Wide" &&
					trip.mine === "Mile 4",
			);
			let calicheListVWT = list.filter(
				(trip) =>
					trip.material === "Caliche" &&
					trip.client === "Valley Wide" &&
					trip.mine === "Texan",
			);
			let calicheListVWRL = list.filter(
				(trip) =>
					trip.material === "Caliche" &&
					trip.client === "Valley Wide" &&
					trip.mine === "Rojo Limestone",
			);
			//CRUSHED34
			//CRUSHED34 - MISSION
			let crushed34ListMM = list.filter(
				(trip) =>
					trip.material === "Crushed 3/4" &&
					trip.client === "Mission" &&
					trip.mine === "Mile 4",
			);
			let crushed34ListMT = list.filter(
				(trip) =>
					trip.material === "Crushed 3/4" &&
					trip.client === "Mission" &&
					trip.mine === "Texan",
			);
			let crushed34ListMRL = list.filter(
				(trip) =>
					trip.material === "Crushed 3/4" &&
					trip.client === "Mission" &&
					trip.mine === "Rojo Limestone",
			);
			//CRUSHED34 - SAN BENITO
			let crushed34ListSBM = list.filter(
				(trip) =>
					trip.material === "Crushed 3/4" &&
					trip.client === "San Benito" &&
					trip.mine === "Mile 4",
			);
			let crushed34ListSBT = list.filter(
				(trip) =>
					trip.material === "Crushed 3/4" &&
					trip.client === "San Benito" &&
					trip.mine === "Texan",
			);
			let crushed34ListSBRL = list.filter(
				(trip) =>
					trip.material === "Crushed 3/4" &&
					trip.client === "San Benito" &&
					trip.mine === "Rojo Limestone",
			);
			//CRUSHED34 - LAREDO
			let crushed34ListLM = list.filter(
				(trip) =>
					trip.material === "Crushed 3/4" &&
					trip.client === "Laredo" &&
					trip.mine === "Mile 4",
			);
			let crushed34ListLT = list.filter(
				(trip) =>
					trip.material === "Crushed 3/4" &&
					trip.client === "Laredo" &&
					trip.mine === "Texan",
			);
			let crushed34ListLRL = list.filter(
				(trip) =>
					trip.material === "Crushed 3/4" &&
					trip.client === "Laredo" &&
					trip.mine === "Rojo Limestone",
			);
			//CRUSHED34 - BROWNSVILLE
			let crushed34ListBM = list.filter(
				(trip) =>
					trip.material === "Crushed 3/4" &&
					trip.client === "Brownsville" &&
					trip.mine === "Mile 4",
			);
			let crushed34ListBT = list.filter(
				(trip) =>
					trip.material === "Crushed 3/4" &&
					trip.client === "Brownsville" &&
					trip.mine === "Texan",
			);
			let crushed34ListBRL = list.filter(
				(trip) =>
					trip.material === "Crushed 3/4" &&
					trip.client === "Brownsville" &&
					trip.mine === "Rojo Limestone",
			);
			//CRUSHED34 - VALLEY WIDE
			let crushed34ListVWM = list.filter(
				(trip) =>
					trip.material === "Crushed 3/4" &&
					trip.client === "Valley Wide" &&
					trip.mine === "Mile 4",
			);
			let crushed34ListVWT = list.filter(
				(trip) =>
					trip.material === "Crushed 3/4" &&
					trip.client === "Valley Wide" &&
					trip.mine === "Texan",
			);
			let crushed34ListVWRL = list.filter(
				(trip) =>
					trip.material === "Crushed 3/4" &&
					trip.client === "Valley Wide" &&
					trip.mine === "Rojo Limestone",
			);
			//LIMESTONE
			//LIMESTONE - MISSION
			let limestoneListMM = list.filter(
				(trip) =>
					trip.material === '1" Limestone' &&
					trip.client === "Mission" &&
					trip.mine === "Mile 4",
			);
			let limestoneListMT = list.filter(
				(trip) =>
					trip.material === '1" Limestone' &&
					trip.client === "Mission" &&
					trip.mine === "Texan",
			);
			let limestoneListMRL = list.filter(
				(trip) =>
					trip.material === '1" Limestone' &&
					trip.client === "Mission" &&
					trip.mine === "Rojo Limestone",
			);
			//LIMESTONE - SAN BENITO
			let limestoneListSBM = list.filter(
				(trip) =>
					trip.material === '1" Limestone' &&
					trip.client === "San Benito" &&
					trip.mine === "Mile 4",
			);
			let limestoneListSBT = list.filter(
				(trip) =>
					trip.material === '1" Limestone' &&
					trip.client === "San Benito" &&
					trip.mine === "Texan",
			);
			let limestoneListSBRL = list.filter(
				(trip) =>
					trip.material === '1" Limestone' &&
					trip.client === "San Benito" &&
					trip.mine === "Rojo Limestone",
			);
			//LIMESTONE - LAREDO
			let limestoneListLM = list.filter(
				(trip) =>
					trip.material === '1" Limestone' &&
					trip.client === "Laredo" &&
					trip.mine === "Mile 4",
			);
			let limestoneListLT = list.filter(
				(trip) =>
					trip.material === '1" Limestone' &&
					trip.client === "Laredo" &&
					trip.mine === "Texan",
			);
			let limestoneListLRL = list.filter(
				(trip) =>
					trip.material === '1" Limestone' &&
					trip.client === "Laredo" &&
					trip.mine === "Rojo Limestone",
			);
			//LIMESTONE - BROWNSVILLE
			let limestoneListBM = list.filter(
				(trip) =>
					trip.material === '1" Limestone' &&
					trip.client === "Brownsville" &&
					trip.mine === "Mile 4",
			);
			let limestoneListBT = list.filter(
				(trip) =>
					trip.material === '1" Limestone' &&
					trip.client === "Brownsville" &&
					trip.mine === "Texan",
			);
			let limestoneListBRL = list.filter(
				(trip) =>
					trip.material === '1" Limestone' &&
					trip.client === "Brownsville" &&
					trip.mine === "Rojo Limestone",
			);
			//LIMESTONE - VALLEY WIDE
			let limestoneListVWM = list.filter(
				(trip) =>
					trip.material === '1" Limestone' &&
					trip.client === "Valley Wide" &&
					trip.mine === "Mile 4",
			);
			let limestoneListVWT = list.filter(
				(trip) =>
					trip.material === '1" Limestone' &&
					trip.client === "Valley Wide" &&
					trip.mine === "Texan",
			);
			let limestoneListVWRL = list.filter(
				(trip) =>
					trip.material === '1" Limestone' &&
					trip.client === "Valley Wide" &&
					trip.mine === "Rojo Limestone",
			);

			const cDate = dayjs(date);

			const formattedDate = `${cDate.get("M") + 1}/${cDate.get(
				"date",
			)}/${cDate.get("y")}`;

			let detailedRowsSand = [];
			if (sandListMM.length > 0) {
				let sumQuantity = 0;

				sandListMM.map((item) => {
					sumQuantity += item.quantity;
				});

				detailedRowsSand.push({
					id: `${formattedDate.replaceAll("/", "")}-S-M-M`,
					quantity: sumQuantity,
					material: "Sand",
					status: sandListMM.length > 0 ? sandListMM[0].jobStatus : "Pouring",
					client: "Mission",
					mine: "Mile 4",
				});
			}
			if (sandListMT.length > 0) {
				let sumQuantity = 0;

				sandListMT.map((item) => {
					sumQuantity += item.quantity;
				});

				detailedRowsSand.push({
					id: `${formattedDate.replaceAll("/", "")}-S-M-T`,
					quantity: sumQuantity,
					material: "Sand",
					status: sandListMT.length > 0 ? sandListMT[0].jobStatus : "Pouring",
					client: "Mission",
					mine: "Texan",
				});
			}
			if (sandListMRL.length > 0) {
				let sumQuantity = 0;

				sandListMRL.map((item) => {
					sumQuantity += item.quantity;
				});

				detailedRowsSand.push({
					id: `${formattedDate.replaceAll("/", "")}-S-M-RL`,
					quantity: sumQuantity,
					material: "Sand",
					status: sandListMRL.length > 0 ? sandListMRL[0].jobStatus : "Pouring",
					client: "Mission",
					mine: "Rojo Limestone",
				});
			}
			if (sandListSBM.length > 0) {
				let sumQuantity = 0;

				sandListSBM.map((item) => {
					sumQuantity += item.quantity;
				});

				detailedRowsSand.push({
					id: `${formattedDate.replaceAll("/", "")}-S-SB-M`,
					quantity: sumQuantity,
					material: "Sand",
					status: sandListSBM.length > 0 ? sandListSBM[0].jobStatus : "Pouring",
					client: "San Benito",
					mine: "Mile 4",
				});
			}
			if (sandListSBT.length > 0) {
				let sumQuantity = 0;

				sandListSBT.map((item) => {
					sumQuantity += item.quantity;
				});

				detailedRowsSand.push({
					id: `${formattedDate.replaceAll("/", "")}-S-SB-T`,
					quantity: sumQuantity,
					material: "Sand",
					status: sandListSBT.length > 0 ? sandListSBT[0].jobStatus : "Pouring",
					client: "San Benito",
					mine: "Texan",
				});
			}
			if (sandListSBRL.length > 0) {
				let sumQuantity = 0;

				sandListSBRL.map((item) => {
					sumQuantity += item.quantity;
				});

				detailedRowsSand.push({
					id: `${formattedDate.replaceAll("/", "")}-S-SB-RL`,
					quantity: sumQuantity,
					material: "Sand",
					status:
						sandListSBRL.length > 0 ? sandListSBRL[0].jobStatus : "Pouring",
					client: "San Benito",
					mine: "Rojo Limestone",
				});
			}
			if (sandListLM.length > 0) {
				let sumQuantity = 0;

				sandListLM.map((item) => {
					sumQuantity += item.quantity;
				});

				detailedRowsSand.push({
					id: `${formattedDate.replaceAll("/", "")}-S-L-M`,
					quantity: sumQuantity,
					material: "Sand",
					status: sandListLM.length > 0 ? sandListLM[0].jobStatus : "Pouring",
					client: "Laredo",
					mine: "Mile 4",
				});
			}
			if (sandListLT.length > 0) {
				let sumQuantity = 0;

				sandListLT.map((item) => {
					sumQuantity += item.quantity;
				});

				detailedRowsSand.push({
					id: `${formattedDate.replaceAll("/", "")}-S-L-T`,
					quantity: sumQuantity,
					material: "Sand",
					status: sandListLT.length > 0 ? sandListLT[0].jobStatus : "Pouring",
					client: "Laredo",
					mine: "Texan",
				});
			}
			if (sandListLRL.length > 0) {
				let sumQuantity = 0;

				sandListLRL.map((item) => {
					sumQuantity += item.quantity;
				});

				detailedRowsSand.push({
					id: `${formattedDate.replaceAll("/", "")}-S-L-RL`,
					quantity: sumQuantity,
					material: "Sand",
					status: sandListLRL.length > 0 ? sandListLRL[0].jobStatus : "Pouring",
					client: "Laredo",
					mine: "Rojo Limestone",
				});
			}
			if (sandListBM.length > 0) {
				let sumQuantity = 0;

				sandListBM.map((item) => {
					sumQuantity += item.quantity;
				});

				detailedRowsSand.push({
					id: `${formattedDate.replaceAll("/", "")}-S-B-M`,
					quantity: sumQuantity,
					material: "Sand",
					status: sandListBM.length > 0 ? sandListBM[0].jobStatus : "Pouring",
					client: "Brownsville",
					mine: "Mile 4",
				});
			}
			if (sandListBT.length > 0) {
				let sumQuantity = 0;

				sandListBT.map((item) => {
					sumQuantity += item.quantity;
				});

				detailedRowsSand.push({
					id: `${formattedDate.replaceAll("/", "")}-S-B-T`,
					quantity: sumQuantity,
					material: "Sand",
					status: sandListBT.length > 0 ? sandListBT[0].jobStatus : "Pouring",
					client: "Brownsville",
					mine: "Texan",
				});
			}
			if (sandListBRL.length > 0) {
				let sumQuantity = 0;

				sandListBRL.map((item) => {
					sumQuantity += item.quantity;
				});

				detailedRowsSand.push({
					id: `${formattedDate.replaceAll("/", "")}-S-B-RL`,
					quantity: sumQuantity,
					material: "Sand",
					status: sandListBRL.length > 0 ? sandListBRL[0].jobStatus : "Pouring",
					client: "Brownsville",
					mine: "Rojo Limestone",
				});
			}
			if (sandListVWM.length > 0) {
				let sumQuantity = 0;

				sandListVWM.map((item) => {
					sumQuantity += item.quantity;
				});

				detailedRowsSand.push({
					id: `${formattedDate.replaceAll("/", "")}-S-VW-M`,
					quantity: sumQuantity,
					material: "Sand",
					status: sandListVWM.length > 0 ? sandListVWM[0].jobStatus : "Pouring",
					client: "Valley Wide",
					mine: "Mile 4",
				});
			}
			if (sandListVWT.length > 0) {
				let sumQuantity = 0;

				sandListVWT.map((item) => {
					sumQuantity += item.quantity;
				});

				detailedRowsSand.push({
					id: `${formattedDate.replaceAll("/", "")}-S-VW-T`,
					quantity: sumQuantity,
					material: "Sand",
					status: sandListVWT.length > 0 ? sandListVWT[0].jobStatus : "Pouring",
					client: "Valley Wide",
					mine: "Texan",
				});
			}
			if (sandListVWRL.length > 0) {
				let sumQuantity = 0;

				sandListVWRL.map((item) => {
					sumQuantity += item.quantity;
				});

				detailedRowsSand.push({
					id: `${formattedDate.replaceAll("/", "")}-S-VW-RL`,
					quantity: sumQuantity,
					material: "Sand",
					status:
						sandListVWRL.length > 0 ? sandListVWRL[0].jobStatus : "Pouring",
					client: "Valley Wide",
					mine: "Rojo Limestone",
				});
			}

			let detailedRowsGravel = [];
			if (gravelListMM.length > 0) {
				let sumQuantity = 0;

				gravelListMM.map((item) => {
					sumQuantity += item.quantity;
				});

				detailedRowsGravel.push({
					id: `${formattedDate.replaceAll("/", "")}-G-M-M`,
					quantity: sumQuantity,
					material: "Gravel",
					status:
						gravelListMM.length > 0 ? gravelListMM[0].jobStatus : "Pouring",
					client: "Mission",
					mine: "Mile 4",
				});
			}
			if (gravelListMT.length > 0) {
				let sumQuantity = 0;

				gravelListMT.map((item) => {
					sumQuantity += item.quantity;
				});

				detailedRowsGravel.push({
					id: `${formattedDate.replaceAll("/", "")}-G-M-T`,
					quantity: sumQuantity,
					material: "Gravel",
					status:
						gravelListMT.length > 0 ? gravelListMT[0].jobStatus : "Pouring",
					client: "Mission",
					mine: "Texan",
				});
			}
			if (gravelListMRL.length > 0) {
				let sumQuantity = 0;

				gravelListMRL.map((item) => {
					sumQuantity += item.quantity;
				});

				detailedRowsGravel.push({
					id: `${formattedDate.replaceAll("/", "")}-G-M-RL`,
					quantity: sumQuantity,
					material: "Gravel",
					status:
						gravelListMRL.length > 0 ? gravelListMRL[0].jobStatus : "Pouring",
					client: "Mission",
					mine: "Rojo Limestone",
				});
			}
			if (gravelListSBM.length > 0) {
				let sumQuantity = 0;

				gravelListSBM.map((item) => {
					sumQuantity += item.quantity;
				});

				detailedRowsGravel.push({
					id: `${formattedDate.replaceAll("/", "")}-G-SB-M`,
					quantity: sumQuantity,
					material: "Gravel",
					status:
						gravelListSBM.length > 0 ? gravelListSBM[0].jobStatus : "Pouring",
					client: "San Benito",
					mine: "Mile 4",
				});
			}
			if (gravelListSBT.length > 0) {
				let sumQuantity = 0;

				gravelListSBT.map((item) => {
					sumQuantity += item.quantity;
				});

				detailedRowsGravel.push({
					id: `${formattedDate.replaceAll("/", "")}-G-SB-T`,
					quantity: sumQuantity,
					material: "Gravel",
					status:
						gravelListSBT.length > 0 ? gravelListSBT[0].jobStatus : "Pouring",
					client: "San Benito",
					mine: "Texan",
				});
			}
			if (gravelListSBRL.length > 0) {
				let sumQuantity = 0;

				gravelListSBRL.map((item) => {
					sumQuantity += item.quantity;
				});

				detailedRowsGravel.push({
					id: `${formattedDate.replaceAll("/", "")}-G-SB-RL`,
					quantity: sumQuantity,
					material: "Gravel",
					status:
						gravelListSBRL.length > 0 ? gravelListSBRL[0].jobStatus : "Pouring",
					client: "San Benito",
					mine: "Rojo Limestone",
				});
			}
			if (gravelListLM.length > 0) {
				let sumQuantity = 0;

				gravelListLM.map((item) => {
					sumQuantity += item.quantity;
				});

				detailedRowsGravel.push({
					id: `${formattedDate.replaceAll("/", "")}-G-L-M`,
					quantity: sumQuantity,
					material: "Gravel",
					status:
						gravelListLM.length > 0 ? gravelListLM[0].jobStatus : "Pouring",
					client: "Laredo",
					mine: "Mile 4",
				});
			}
			if (gravelListLT.length > 0) {
				let sumQuantity = 0;

				gravelListLT.map((item) => {
					sumQuantity += item.quantity;
				});

				detailedRowsGravel.push({
					id: `${formattedDate.replaceAll("/", "")}-G-L-T`,
					quantity: sumQuantity,
					material: "Gravel",
					status:
						gravelListLT.length > 0 ? gravelListLT[0].jobStatus : "Pouring",
					client: "Laredo",
					mine: "Texan",
				});
			}
			if (gravelListLRL.length > 0) {
				let sumQuantity = 0;

				gravelListLRL.map((item) => {
					sumQuantity += item.quantity;
				});

				detailedRowsGravel.push({
					id: `${formattedDate.replaceAll("/", "")}-G-L-RL`,
					quantity: sumQuantity,
					material: "Gravel",
					status:
						gravelListLRL.length > 0 ? gravelListLRL[0].jobStatus : "Pouring",
					client: "Laredo",
					mine: "Rojo Limestone",
				});
			}
			if (gravelListBM.length > 0) {
				let sumQuantity = 0;

				gravelListBM.map((item) => {
					sumQuantity += item.quantity;
				});

				detailedRowsGravel.push({
					id: `${formattedDate.replaceAll("/", "")}-G-B-M`,
					quantity: sumQuantity,
					material: "Gravel",
					status:
						gravelListBM.length > 0 ? gravelListBM[0].jobStatus : "Pouring",
					client: "Brownsville",
					mine: "Mile 4",
				});
			}
			if (gravelListBT.length > 0) {
				let sumQuantity = 0;

				gravelListBT.map((item) => {
					sumQuantity += item.quantity;
				});

				detailedRowsGravel.push({
					id: `${formattedDate.replaceAll("/", "")}-G-B-T`,
					quantity: sumQuantity,
					material: "Gravel",
					status:
						gravelListBT.length > 0 ? gravelListBT[0].jobStatus : "Pouring",
					client: "Brownsville",
					mine: "Texan",
				});
			}
			if (gravelListBRL.length > 0) {
				let sumQuantity = 0;

				gravelListBRL.map((item) => {
					sumQuantity += item.quantity;
				});

				detailedRowsGravel.push({
					id: `${formattedDate.replaceAll("/", "")}-G-B-RL`,
					quantity: sumQuantity,
					material: "Gravel",
					status:
						gravelListBRL.length > 0 ? gravelListBRL[0].jobStatus : "Pouring",
					client: "Brownsville",
					mine: "Rojo Limestone",
				});
			}
			if (gravelListVWM.length > 0) {
				let sumQuantity = 0;

				gravelListVWM.map((item) => {
					sumQuantity += item.quantity;
				});

				detailedRowsGravel.push({
					id: `${formattedDate.replaceAll("/", "")}-G-VW-M`,
					quantity: sumQuantity,
					material: "Gravel",
					status:
						gravelListVWM.length > 0 ? gravelListVWM[0].jobStatus : "Pouring",
					client: "Valley Wide",
					mine: "Mile 4",
				});
			}
			if (gravelListVWT.length > 0) {
				let sumQuantity = 0;

				gravelListVWT.map((item) => {
					sumQuantity += item.quantity;
				});

				detailedRowsGravel.push({
					id: `${formattedDate.replaceAll("/", "")}-G-VW-T`,
					quantity: sumQuantity,
					material: "Gravel",
					status:
						gravelListVWT.length > 0 ? gravelListVWT[0].jobStatus : "Pouring",
					client: "Valley Wide",
					mine: "Texan",
				});
			}
			if (gravelListVWRL.length > 0) {
				let sumQuantity = 0;

				gravelListVWRL.map((item) => {
					sumQuantity += item.quantity;
				});

				detailedRowsGravel.push({
					id: `${formattedDate.replaceAll("/", "")}-G-VW-RL`,
					quantity: sumQuantity,
					material: "Gravel",
					status:
						gravelListVWRL.length > 0 ? gravelListVWRL[0].jobStatus : "Pouring",
					client: "Valley Wide",
					mine: "Rojo Limestone",
				});
			}

			let detailedRowsPeaGravel = [];
			if (peaGravelListMM.length > 0) {
				let sumQuantity = 0;

				peaGravelListMM.map((item) => {
					sumQuantity += item.quantity;
				});

				detailedRowsPeaGravel.push({
					id: `${formattedDate.replaceAll("/", "")}-PG-M-M`,
					quantity: sumQuantity,
					material: "Pea Gravel",
					status:
						peaGravelListMM.length > 0
							? peaGravelListMM[0].jobStatus
							: "Pouring",
					client: "Mission",
					mine: "Mile 4",
				});
			}
			if (peaGravelListMT.length > 0) {
				let sumQuantity = 0;

				peaGravelListMT.map((item) => {
					sumQuantity += item.quantity;
				});

				detailedRowsPeaGravel.push({
					id: `${formattedDate.replaceAll("/", "")}-PG-M-T`,
					quantity: sumQuantity,
					material: "Pea Gravel",
					status:
						peaGravelListMT.length > 0
							? peaGravelListMT[0].jobStatus
							: "Pouring",
					client: "Mission",
					mine: "Texan",
				});
			}
			if (peaGravelListMRL.length > 0) {
				let sumQuantity = 0;

				peaGravelListMRL.map((item) => {
					sumQuantity += item.quantity;
				});

				detailedRowsPeaGravel.push({
					id: `${formattedDate.replaceAll("/", "")}-PG-M-RL`,
					quantity: sumQuantity,
					material: "Pea Gravel",
					status:
						peaGravelListMRL.length > 0
							? peaGravelListMRL[0].jobStatus
							: "Pouring",
					client: "Mission",
					mine: "Rojo Limestone",
				});
			}
			if (peaGravelListSBM.length > 0) {
				let sumQuantity = 0;

				peaGravelListSBM.map((item) => {
					sumQuantity += item.quantity;
				});

				detailedRowsPeaGravel.push({
					id: `${formattedDate.replaceAll("/", "")}-PG-SB-M`,
					quantity: sumQuantity,
					material: "Pea Gravel",
					status:
						peaGravelListSBM.length > 0
							? peaGravelListSBM[0].jobStatus
							: "Pouring",
					client: "San Benito",
					mine: "Mile 4",
				});
			}
			if (peaGravelListSBT.length > 0) {
				let sumQuantity = 0;

				peaGravelListSBT.map((item) => {
					sumQuantity += item.quantity;
				});

				detailedRowsPeaGravel.push({
					id: `${formattedDate.replaceAll("/", "")}-PG-SB-T`,
					quantity: sumQuantity,
					material: "Pea Gravel",
					status:
						peaGravelListSBT.length > 0
							? peaGravelListSBT[0].jobStatus
							: "Pouring",
					client: "San Benito",
					mine: "Texan",
				});
			}
			if (peaGravelListSBRL.length > 0) {
				let sumQuantity = 0;

				peaGravelListSBRL.map((item) => {
					sumQuantity += item.quantity;
				});

				detailedRowsPeaGravel.push({
					id: `${formattedDate.replaceAll("/", "")}-PG-SB-RL`,
					quantity: sumQuantity,
					material: "Pea Gravel",
					status:
						peaGravelListSBRL.length > 0
							? peaGravelListSBRL[0].jobStatus
							: "Pouring",
					client: "San Benito",
					mine: "Rojo Limestone",
				});
			}
			if (peaGravelListLM.length > 0) {
				let sumQuantity = 0;

				peaGravelListLM.map((item) => {
					sumQuantity += item.quantity;
				});

				detailedRowsPeaGravel.push({
					id: `${formattedDate.replaceAll("/", "")}-PG-L-M`,
					quantity: sumQuantity,
					material: "Pea Gravel",
					status:
						peaGravelListLM.length > 0
							? peaGravelListLM[0].jobStatus
							: "Pouring",
					client: "Laredo",
					mine: "Mile 4",
				});
			}
			if (peaGravelListLT.length > 0) {
				let sumQuantity = 0;

				peaGravelListLT.map((item) => {
					sumQuantity += item.quantity;
				});

				detailedRowsPeaGravel.push({
					id: `${formattedDate.replaceAll("/", "")}-PG-L-T`,
					quantity: sumQuantity,
					material: "Pea Gravel",
					status:
						peaGravelListLT.length > 0
							? peaGravelListLT[0].jobStatus
							: "Pouring",
					client: "Laredo",
					mine: "Texan",
				});
			}
			if (peaGravelListLRL.length > 0) {
				let sumQuantity = 0;

				peaGravelListLRL.map((item) => {
					sumQuantity += item.quantity;
				});

				detailedRowsPeaGravel.push({
					id: `${formattedDate.replaceAll("/", "")}-PG-L-RL`,
					quantity: sumQuantity,
					material: "Pea Gravel",
					status:
						peaGravelListLRL.length > 0
							? peaGravelListLRL[0].jobStatus
							: "Pouring",
					client: "Laredo",
					mine: "Rojo Limestone",
				});
			}
			if (peaGravelListBM.length > 0) {
				let sumQuantity = 0;

				peaGravelListBM.map((item) => {
					sumQuantity += item.quantity;
				});

				detailedRowsPeaGravel.push({
					id: `${formattedDate.replaceAll("/", "")}-PG-B-M`,
					quantity: sumQuantity,
					material: "Pea Gravel",
					status:
						peaGravelListBM.length > 0
							? peaGravelListBM[0].jobStatus
							: "Pouring",
					client: "Brownsville",
					mine: "Mile 4",
				});
			}
			if (peaGravelListBT.length > 0) {
				let sumQuantity = 0;

				peaGravelListBT.map((item) => {
					sumQuantity += item.quantity;
				});

				detailedRowsPeaGravel.push({
					id: `${formattedDate.replaceAll("/", "")}-PG-B-T`,
					quantity: sumQuantity,
					material: "Pea Gravel",
					status:
						peaGravelListBT.length > 0
							? peaGravelListBT[0].jobStatus
							: "Pouring",
					client: "Brownsville",
					mine: "Texan",
				});
			}
			if (peaGravelListBRL.length > 0) {
				let sumQuantity = 0;

				peaGravelListBRL.map((item) => {
					sumQuantity += item.quantity;
				});

				detailedRowsPeaGravel.push({
					id: `${formattedDate.replaceAll("/", "")}-PG-B-RL`,
					quantity: sumQuantity,
					material: "Pea Gravel",
					status:
						peaGravelListBRL.length > 0
							? peaGravelListBRL[0].jobStatus
							: "Pouring",
					client: "Brownsville",
					mine: "Rojo Limestone",
				});
			}
			if (peaGravelListVWM.length > 0) {
				let sumQuantity = 0;

				peaGravelListVWM.map((item) => {
					sumQuantity += item.quantity;
				});

				detailedRowsPeaGravel.push({
					id: `${formattedDate.replaceAll("/", "")}-PG-VW-M`,
					quantity: sumQuantity,
					material: "Pea Gravel",
					status:
						peaGravelListVWM.length > 0
							? peaGravelListVWM[0].jobStatus
							: "Pouring",
					client: "Valley Wide",
					mine: "Mile 4",
				});
			}
			if (peaGravelListVWT.length > 0) {
				let sumQuantity = 0;

				peaGravelListVWT.map((item) => {
					sumQuantity += item.quantity;
				});

				detailedRowsPeaGravel.push({
					id: `${formattedDate.replaceAll("/", "")}-PG-VW-T`,
					quantity: sumQuantity,
					material: "Pea Gravel",
					status:
						peaGravelListVWT.length > 0
							? peaGravelListVWT[0].jobStatus
							: "Pouring",
					client: "Valley Wide",
					mine: "Texan",
				});
			}
			if (peaGravelListVWRL.length > 0) {
				let sumQuantity = 0;

				peaGravelListVWRL.map((item) => {
					sumQuantity += item.quantity;
				});

				detailedRowsPeaGravel.push({
					id: `${formattedDate.replaceAll("/", "")}-PG-VW-RL`,
					quantity: sumQuantity,
					material: "Pea Gravel",
					status:
						peaGravelListVWRL.length > 0
							? peaGravelListVWRL[0].jobStatus
							: "Pouring",
					client: "Valley Wide",
					mine: "Rojo Limestone",
				});
			}

			let detailedRowsCaliche = [];
			if (calicheListMM.length > 0) {
				let sumQuantity = 0;

				calicheListMM.map((item) => {
					sumQuantity += item.quantity;
				});

				detailedRowsCaliche.push({
					id: `${formattedDate.replaceAll("/", "")}-C-M-M`,
					quantity: sumQuantity,
					material: "Caliche",
					status:
						calicheListMM.length > 0 ? calicheListMM[0].jobStatus : "Pouring",
					client: "Mission",
					mine: "Mile 4",
				});
			}
			if (calicheListMT.length > 0) {
				let sumQuantity = 0;

				calicheListMT.map((item) => {
					sumQuantity += item.quantity;
				});

				detailedRowsCaliche.push({
					id: `${formattedDate.replaceAll("/", "")}-C-M-T`,
					quantity: sumQuantity,
					material: "Caliche",
					status:
						calicheListMT.length > 0 ? calicheListMT[0].jobStatus : "Pouring",
					client: "Mission",
					mine: "Texan",
				});
			}
			if (calicheListMRL.length > 0) {
				let sumQuantity = 0;

				calicheListMRL.map((item) => {
					sumQuantity += item.quantity;
				});

				detailedRowsCaliche.push({
					id: `${formattedDate.replaceAll("/", "")}-C-M-RL`,
					quantity: sumQuantity,
					material: "Caliche",
					status:
						calicheListMRL.length > 0 ? calicheListMRL[0].jobStatus : "Pouring",
					client: "Mission",
					mine: "Rojo Limestone",
				});
			}
			if (calicheListSBM.length > 0) {
				let sumQuantity = 0;

				calicheListSBM.map((item) => {
					sumQuantity += item.quantity;
				});

				detailedRowsCaliche.push({
					id: `${formattedDate.replaceAll("/", "")}-C-SB-M`,
					quantity: sumQuantity,
					material: "Caliche",
					status:
						calicheListSBM.length > 0 ? calicheListSBM[0].jobStatus : "Pouring",
					client: "San Benito",
					mine: "Mile 4",
				});
			}
			if (calicheListSBT.length > 0) {
				let sumQuantity = 0;

				calicheListSBT.map((item) => {
					sumQuantity += item.quantity;
				});

				detailedRowsCaliche.push({
					id: `${formattedDate.replaceAll("/", "")}-C-SB-T`,
					quantity: sumQuantity,
					material: "Caliche",
					status:
						calicheListSBT.length > 0 ? calicheListSBT[0].jobStatus : "Pouring",
					client: "San Benito",
					mine: "Texan",
				});
			}
			if (calicheListSBRL.length > 0) {
				let sumQuantity = 0;

				calicheListSBRL.map((item) => {
					sumQuantity += item.quantity;
				});

				detailedRowsCaliche.push({
					id: `${formattedDate.replaceAll("/", "")}-C-SB-RL`,
					quantity: sumQuantity,
					material: "Caliche",
					status:
						calicheListSBRL.length > 0
							? calicheListSBRL[0].jobStatus
							: "Pouring",
					client: "San Benito",
					mine: "Rojo Limestone",
				});
			}
			if (calicheListLM.length > 0) {
				let sumQuantity = 0;

				calicheListLM.map((item) => {
					sumQuantity += item.quantity;
				});

				detailedRowsCaliche.push({
					id: `${formattedDate.replaceAll("/", "")}-C-L-M`,
					quantity: sumQuantity,
					material: "Caliche",
					status:
						calicheListLM.length > 0 ? calicheListLM[0].jobStatus : "Pouring",
					client: "Laredo",
					mine: "Mile 4",
				});
			}
			if (calicheListLT.length > 0) {
				let sumQuantity = 0;

				calicheListLT.map((item) => {
					sumQuantity += item.quantity;
				});

				detailedRowsCaliche.push({
					id: `${formattedDate.replaceAll("/", "")}-C-L-T`,
					quantity: sumQuantity,
					material: "Caliche",
					status:
						calicheListLT.length > 0 ? calicheListLT[0].jobStatus : "Pouring",
					client: "Laredo",
					mine: "Texan",
				});
			}
			if (calicheListLRL.length > 0) {
				let sumQuantity = 0;

				calicheListLRL.map((item) => {
					sumQuantity += item.quantity;
				});

				detailedRowsCaliche.push({
					id: `${formattedDate.replaceAll("/", "")}-C-L-RL`,
					quantity: sumQuantity,
					material: "Caliche",
					status:
						calicheListLRL.length > 0 ? calicheListLRL[0].jobStatus : "Pouring",
					client: "Laredo",
					mine: "Rojo Limestone",
				});
			}
			if (calicheListBM.length > 0) {
				let sumQuantity = 0;

				calicheListBM.map((item) => {
					sumQuantity += item.quantity;
				});

				detailedRowsCaliche.push({
					id: `${formattedDate.replaceAll("/", "")}-C-B-M`,
					quantity: sumQuantity,
					material: "Caliche",
					status:
						calicheListBM.length > 0 ? calicheListBM[0].jobStatus : "Pouring",
					client: "Brownsville",
					mine: "Mile 4",
				});
			}
			if (calicheListBT.length > 0) {
				let sumQuantity = 0;

				calicheListBT.map((item) => {
					sumQuantity += item.quantity;
				});

				detailedRowsCaliche.push({
					id: `${formattedDate.replaceAll("/", "")}-C-B-T`,
					quantity: sumQuantity,
					material: "Caliche",
					status:
						calicheListBT.length > 0 ? calicheListBT[0].jobStatus : "Pouring",
					client: "Brownsville",
					mine: "Texan",
				});
			}
			if (calicheListBRL.length > 0) {
				let sumQuantity = 0;

				calicheListBRL.map((item) => {
					sumQuantity += item.quantity;
				});

				detailedRowsCaliche.push({
					id: `${formattedDate.replaceAll("/", "")}-C-B-RL`,
					quantity: sumQuantity,
					material: "Caliche",
					status:
						calicheListBRL.length > 0 ? calicheListBRL[0].jobStatus : "Pouring",
					client: "Brownsville",
					mine: "Rojo Limestone",
				});
			}
			if (calicheListVWM.length > 0) {
				let sumQuantity = 0;

				calicheListVWM.map((item) => {
					sumQuantity += item.quantity;
				});

				detailedRowsCaliche.push({
					id: `${formattedDate.replaceAll("/", "")}-C-VW-M`,
					quantity: sumQuantity,
					material: "Caliche",
					status:
						calicheListVWM.length > 0 ? calicheListVWM[0].jobStatus : "Pouring",
					client: "Valley Wide",
					mine: "Mile 4",
				});
			}
			if (calicheListVWT.length > 0) {
				let sumQuantity = 0;

				calicheListVWT.map((item) => {
					sumQuantity += item.quantity;
				});

				detailedRowsCaliche.push({
					id: `${formattedDate.replaceAll("/", "")}-C-VW-T`,
					quantity: sumQuantity,
					material: "Caliche",
					status:
						calicheListVWT.length > 0 ? calicheListVWT[0].jobStatus : "Pouring",
					client: "Valley Wide",
					mine: "Texan",
				});
			}
			if (calicheListVWRL.length > 0) {
				let sumQuantity = 0;

				calicheListVWRL.map((item) => {
					sumQuantity += item.quantity;
				});

				detailedRowsCaliche.push({
					id: `${formattedDate.replaceAll("/", "")}-C-VW-RL`,
					quantity: sumQuantity,
					material: "Caliche",
					status:
						calicheListVWRL.length > 0
							? calicheListVWRL[0].jobStatus
							: "Pouring",
					client: "Valley Wide",
					mine: "Rojo Limestone",
				});
			}

			//// los nuevos
			let detailedRowsCrushed34 = [];
			if (crushed34ListMM.length > 0) {
				let sumQuantity = 0;

				crushed34ListMM.map((item) => {
					sumQuantity += item.quantity;
				});

				detailedRowsCrushed34.push({
					id: `${formattedDate.replaceAll("/", "")}-C34-M-M`,
					quantity: sumQuantity,
					material: "Crushed 3/4",
					status:
						crushed34ListMM.length > 0
							? crushed34ListMM[0].jobStatus
							: "Pouring",
					client: "Mission",
					mine: "Mile 4",
				});
			}
			if (crushed34ListMT.length > 0) {
				let sumQuantity = 0;

				crushed34ListMT.map((item) => {
					sumQuantity += item.quantity;
				});

				detailedRowsCrushed34.push({
					id: `${formattedDate.replaceAll("/", "")}-C34-M-T`,
					quantity: sumQuantity,
					material: "Crushed 3/4",
					status:
						crushed34ListMT.length > 0
							? crushed34ListMT[0].jobStatus
							: "Pouring",
					client: "Mission",
					mine: "Texan",
				});
			}
			if (crushed34ListMRL.length > 0) {
				let sumQuantity = 0;

				crushed34ListMRL.map((item) => {
					sumQuantity += item.quantity;
				});

				detailedRowsCrushed34.push({
					id: `${formattedDate.replaceAll("/", "")}-C34-M-RL`,
					quantity: sumQuantity,
					material: "Crushed 3/4",
					status:
						crushed34ListMRL.length > 0
							? crushed34ListMRL[0].jobStatus
							: "Pouring",
					client: "Mission",
					mine: "Rojo Limestone",
				});
			}
			if (crushed34ListSBM.length > 0) {
				let sumQuantity = 0;

				crushed34ListSBM.map((item) => {
					sumQuantity += item.quantity;
				});

				detailedRowsCrushed34.push({
					id: `${formattedDate.replaceAll("/", "")}-C34-SB-M`,
					quantity: sumQuantity,
					material: "Crushed 3/4",
					status:
						crushed34ListSBM.length > 0
							? crushed34ListSBM[0].jobStatus
							: "Pouring",
					client: "San Benito",
					mine: "Mile 4",
				});
			}
			if (crushed34ListSBT.length > 0) {
				let sumQuantity = 0;

				crushed34ListSBT.map((item) => {
					sumQuantity += item.quantity;
				});

				detailedRowsCrushed34.push({
					id: `${formattedDate.replaceAll("/", "")}-C34-SB-T`,
					quantity: sumQuantity,
					material: "Crushed 3/4",
					status:
						crushed34ListSBT.length > 0
							? crushed34ListSBT[0].jobStatus
							: "Pouring",
					client: "San Benito",
					mine: "Texan",
				});
			}
			if (crushed34ListSBRL.length > 0) {
				let sumQuantity = 0;

				crushed34ListSBRL.map((item) => {
					sumQuantity += item.quantity;
				});

				detailedRowsCrushed34.push({
					id: `${formattedDate.replaceAll("/", "")}-C34-SB-RL`,
					quantity: sumQuantity,
					material: "Crushed 3/4",
					status:
						crushed34ListSBRL.length > 0
							? crushed34ListSBRL[0].jobStatus
							: "Pouring",
					client: "San Benito",
					mine: "Rojo Limestone",
				});
			}
			if (crushed34ListLM.length > 0) {
				let sumQuantity = 0;

				crushed34ListLM.map((item) => {
					sumQuantity += item.quantity;
				});

				detailedRowsCrushed34.push({
					id: `${formattedDate.replaceAll("/", "")}-C34-L-M`,
					quantity: sumQuantity,
					material: "Crushed 3/4",
					status:
						crushed34ListLM.length > 0
							? crushed34ListLM[0].jobStatus
							: "Pouring",
					client: "Laredo",
					mine: "Mile 4",
				});
			}
			if (crushed34ListLT.length > 0) {
				let sumQuantity = 0;

				crushed34ListLT.map((item) => {
					sumQuantity += item.quantity;
				});

				detailedRowsCrushed34.push({
					id: `${formattedDate.replaceAll("/", "")}-C34-L-T`,
					quantity: sumQuantity,
					material: "Crushed 3/4",
					status:
						crushed34ListLT.length > 0
							? crushed34ListLT[0].jobStatus
							: "Pouring",
					client: "Laredo",
					mine: "Texan",
				});
			}
			if (crushed34ListLRL.length > 0) {
				let sumQuantity = 0;

				crushed34ListLRL.map((item) => {
					sumQuantity += item.quantity;
				});

				detailedRowsCrushed34.push({
					id: `${formattedDate.replaceAll("/", "")}-C34-L-RL`,
					quantity: sumQuantity,
					material: "Crushed 3/4",
					status:
						crushed34ListLRL.length > 0
							? crushed34ListLRL[0].jobStatus
							: "Pouring",
					client: "Laredo",
					mine: "Rojo Limestone",
				});
			}
			if (crushed34ListBM.length > 0) {
				let sumQuantity = 0;

				crushed34ListBM.map((item) => {
					sumQuantity += item.quantity;
				});

				detailedRowsCrushed34.push({
					id: `${formattedDate.replaceAll("/", "")}-C34-B-M`,
					quantity: sumQuantity,
					material: "Crushed 3/4",
					status:
						crushed34ListBM.length > 0
							? crushed34ListBM[0].jobStatus
							: "Pouring",
					client: "Brownsville",
					mine: "Mile 4",
				});
			}
			if (crushed34ListBT.length > 0) {
				let sumQuantity = 0;

				crushed34ListBT.map((item) => {
					sumQuantity += item.quantity;
				});

				detailedRowsCrushed34.push({
					id: `${formattedDate.replaceAll("/", "")}-C34-B-T`,
					quantity: sumQuantity,
					material: "Crushed 3/4",
					status:
						crushed34ListBT.length > 0
							? crushed34ListBT[0].jobStatus
							: "Pouring",
					client: "Brownsville",
					mine: "Texan",
				});
			}
			if (crushed34ListBRL.length > 0) {
				let sumQuantity = 0;

				crushed34ListBRL.map((item) => {
					sumQuantity += item.quantity;
				});

				detailedRowsCrushed34.push({
					id: `${formattedDate.replaceAll("/", "")}-C34-B-RL`,
					quantity: sumQuantity,
					material: "Crushed 3/4",
					status:
						crushed34ListBRL.length > 0
							? crushed34ListBRL[0].jobStatus
							: "Pouring",
					client: "Brownsville",
					mine: "Rojo Limestone",
				});
			}
			if (crushed34ListVWM.length > 0) {
				let sumQuantity = 0;

				crushed34ListVWM.map((item) => {
					sumQuantity += item.quantity;
				});

				detailedRowsCrushed34.push({
					id: `${formattedDate.replaceAll("/", "")}-C34-VW-M`,
					quantity: sumQuantity,
					material: "Crushed 3/4",
					status:
						crushed34ListVWM.length > 0
							? crushed34ListVWM[0].jobStatus
							: "Pouring",
					client: "Valley Wide",
					mine: "Mile 4",
				});
			}
			if (crushed34ListVWT.length > 0) {
				let sumQuantity = 0;

				crushed34ListVWT.map((item) => {
					sumQuantity += item.quantity;
				});

				detailedRowsCrushed34.push({
					id: `${formattedDate.replaceAll("/", "")}-C34-VW-T`,
					quantity: sumQuantity,
					material: "Crushed 3/4",
					status:
						crushed34ListVWT.length > 0
							? crushed34ListVWT[0].jobStatus
							: "Pouring",
					client: "Valley Wide",
					mine: "Texan",
				});
			}
			if (crushed34ListVWRL.length > 0) {
				let sumQuantity = 0;

				crushed34ListVWRL.map((item) => {
					sumQuantity += item.quantity;
				});

				detailedRowsCrushed34.push({
					id: `${formattedDate.replaceAll("/", "")}-C34-VW-RL`,
					quantity: sumQuantity,
					material: "Crushed 3/4",
					status:
						crushed34ListVWRL.length > 0
							? crushed34ListVWRL[0].jobStatus
							: "Pouring",
					client: "Valley Wide",
					mine: "Rojo Limestone",
				});
			}

			//// los nuevos limestone
			let detailedRowsLimestone = [];
			if (limestoneListMM.length > 0) {
				let sumQuantity = 0;

				limestoneListMM.map((item) => {
					sumQuantity += item.quantity;
				});

				detailedRowsLimestone.push({
					id: `${formattedDate.replaceAll("/", "")}-L-M-M`,
					quantity: sumQuantity,
					material: '1" Limestone',
					status:
						limestoneListMM.length > 0
							? limestoneListMM[0].jobStatus
							: "Pouring",
					client: "Mission",
					mine: "Mile 4",
				});
			}
			if (limestoneListMT.length > 0) {
				let sumQuantity = 0;

				limestoneListMT.map((item) => {
					sumQuantity += item.quantity;
				});

				detailedRowsLimestone.push({
					id: `${formattedDate.replaceAll("/", "")}-L-M-T`,
					quantity: sumQuantity,
					material: '1" Limestone',
					status:
						limestoneListMT.length > 0
							? limestoneListMT[0].jobStatus
							: "Pouring",
					client: "Mission",
					mine: "Texan",
				});
			}
			if (limestoneListMRL.length > 0) {
				let sumQuantity = 0;

				limestoneListMRL.map((item) => {
					sumQuantity += item.quantity;
				});

				detailedRowsLimestone.push({
					id: `${formattedDate.replaceAll("/", "")}-L-M-RL`,
					quantity: sumQuantity,
					material: '1" Limestone',
					status:
						limestoneListMRL.length > 0
							? limestoneListMRL[0].jobStatus
							: "Pouring",
					client: "Mission",
					mine: "Rojo Limestone",
				});
			}
			if (limestoneListSBM.length > 0) {
				let sumQuantity = 0;

				limestoneListSBM.map((item) => {
					sumQuantity += item.quantity;
				});

				detailedRowsLimestone.push({
					id: `${formattedDate.replaceAll("/", "")}-L-SB-M`,
					quantity: sumQuantity,
					material: '1" Limestone',
					status:
						limestoneListSBM.length > 0
							? limestoneListSBM[0].jobStatus
							: "Pouring",
					client: "San Benito",
					mine: "Mile 4",
				});
			}
			if (limestoneListSBT.length > 0) {
				let sumQuantity = 0;

				limestoneListSBT.map((item) => {
					sumQuantity += item.quantity;
				});

				detailedRowsLimestone.push({
					id: `${formattedDate.replaceAll("/", "")}-L-SB-T`,
					quantity: sumQuantity,
					material: '1" Limestone',
					status:
						limestoneListSBT.length > 0
							? limestoneListSBT[0].jobStatus
							: "Pouring",
					client: "San Benito",
					mine: "Texan",
				});
			}
			if (limestoneListSBRL.length > 0) {
				let sumQuantity = 0;

				limestoneListSBRL.map((item) => {
					sumQuantity += item.quantity;
				});

				detailedRowsLimestone.push({
					id: `${formattedDate.replaceAll("/", "")}-L-SB-RL`,
					quantity: sumQuantity,
					material: '1" Limestone',
					status:
						limestoneListSBRL.length > 0
							? limestoneListSBRL[0].jobStatus
							: "Pouring",
					client: "San Benito",
					mine: "Rojo Limestone",
				});
			}
			if (limestoneListLM.length > 0) {
				let sumQuantity = 0;

				limestoneListLM.map((item) => {
					sumQuantity += item.quantity;
				});

				detailedRowsLimestone.push({
					id: `${formattedDate.replaceAll("/", "")}-L-L-M`,
					quantity: sumQuantity,
					material: '1" Limestone',
					status:
						limestoneListLM.length > 0
							? limestoneListLM[0].jobStatus
							: "Pouring",
					client: "Laredo",
					mine: "Mile 4",
				});
			}
			if (limestoneListLT.length > 0) {
				let sumQuantity = 0;

				limestoneListLT.map((item) => {
					sumQuantity += item.quantity;
				});

				detailedRowsLimestone.push({
					id: `${formattedDate.replaceAll("/", "")}-L-L-T`,
					quantity: sumQuantity,
					material: '1" Limestone',
					status:
						limestoneListLT.length > 0
							? limestoneListLT[0].jobStatus
							: "Pouring",
					client: "Laredo",
					mine: "Texan",
				});
			}
			if (limestoneListLRL.length > 0) {
				let sumQuantity = 0;

				limestoneListLRL.map((item) => {
					sumQuantity += item.quantity;
				});

				detailedRowsLimestone.push({
					id: `${formattedDate.replaceAll("/", "")}-L-L-RL`,
					quantity: sumQuantity,
					material: '1" Limestone',
					status:
						limestoneListLRL.length > 0
							? limestoneListLRL[0].jobStatus
							: "Pouring",
					client: "Laredo",
					mine: "Rojo Limestone",
				});
			}
			if (limestoneListBM.length > 0) {
				let sumQuantity = 0;

				limestoneListBM.map((item) => {
					sumQuantity += item.quantity;
				});

				detailedRowsLimestone.push({
					id: `${formattedDate.replaceAll("/", "")}-L-B-M`,
					quantity: sumQuantity,
					material: '1" Limestone',
					status:
						limestoneListBM.length > 0
							? limestoneListBM[0].jobStatus
							: "Pouring",
					client: "Brownsville",
					mine: "Mile 4",
				});
			}
			if (limestoneListBT.length > 0) {
				let sumQuantity = 0;

				limestoneListBT.map((item) => {
					sumQuantity += item.quantity;
				});

				detailedRowsLimestone.push({
					id: `${formattedDate.replaceAll("/", "")}-L-B-T`,
					quantity: sumQuantity,
					material: '1" Limestone',
					status:
						limestoneListBT.length > 0
							? limestoneListBT[0].jobStatus
							: "Pouring",
					client: "Brownsville",
					mine: "Texan",
				});
			}
			if (limestoneListBRL.length > 0) {
				let sumQuantity = 0;

				limestoneListBRL.map((item) => {
					sumQuantity += item.quantity;
				});

				detailedRowsLimestone.push({
					id: `${formattedDate.replaceAll("/", "")}-L-B-RL`,
					quantity: sumQuantity,
					material: '1" Limestone',
					status:
						limestoneListBRL.length > 0
							? limestoneListBRL[0].jobStatus
							: "Pouring",
					client: "Brownsville",
					mine: "Rojo Limestone",
				});
			}
			if (limestoneListVWM.length > 0) {
				let sumQuantity = 0;

				limestoneListVWM.map((item) => {
					sumQuantity += item.quantity;
				});

				detailedRowsLimestone.push({
					id: `${formattedDate.replaceAll("/", "")}-L-VW-M`,
					quantity: sumQuantity,
					material: '1" Limestone',
					status:
						limestoneListVWM.length > 0
							? limestoneListVWM[0].jobStatus
							: "Pouring",
					client: "Valley Wide",
					mine: "Mile 4",
				});
			}
			if (limestoneListVWT.length > 0) {
				let sumQuantity = 0;

				limestoneListVWT.map((item) => {
					sumQuantity += item.quantity;
				});

				detailedRowsLimestone.push({
					id: `${formattedDate.replaceAll("/", "")}-L-VW-T`,
					quantity: sumQuantity,
					material: '1" Limestone',
					status:
						limestoneListVWT.length > 0
							? limestoneListVWT[0].jobStatus
							: "Pouring",
					client: "Valley Wide",
					mine: "Texan",
				});
			}
			if (limestoneListVWRL.length > 0) {
				let sumQuantity = 0;

				limestoneListVWRL.map((item) => {
					sumQuantity += item.quantity;
				});

				detailedRowsLimestone.push({
					id: `${formattedDate.replaceAll("/", "")}-L-VW-RL`,
					quantity: sumQuantity,
					material: '1" Limestone',
					status:
						limestoneListVWRL.length > 0
							? limestoneListVWRL[0].jobStatus
							: "Pouring",
					client: "Valley Wide",
					mine: "Rojo Limestone",
				});
			}

			setDetailedData([
				detailedRowsSand,
				detailedRowsGravel,
				detailedRowsPeaGravel,
				detailedRowsCaliche,
				detailedRowsCrushed34,
				detailedRowsLimestone,
			]);

			setDataExport([
				...detailedRowsSand,
				...detailedRowsGravel,
				...detailedRowsPeaGravel,
				...detailedRowsCaliche,
				...detailedRowsCrushed34,
				...detailedRowsLimestone,
			]);

			setSandList([
				...sandListMM,
				...sandListMT,
				...sandListMRL,
				...sandListSBM,
				...sandListSBT,
				...sandListSBRL,
				...sandListLM,
				...sandListLT,
				...sandListLRL,
				...sandListBM,
				...sandListBT,
				...sandListBRL,
				...sandListVWM,
				...sandListVWT,
				...sandListVWRL,
			]);
			setGravelList([
				...gravelListMM,
				...gravelListMT,
				...gravelListMRL,
				...gravelListSBM,
				...gravelListSBT,
				...gravelListSBRL,
				...gravelListLM,
				...gravelListLT,
				...gravelListLRL,
				...gravelListBM,
				...gravelListBT,
				...gravelListBRL,
				...gravelListVWM,
				...gravelListVWT,
				...gravelListVWRL,
			]);
			setPeaGravelList([
				...peaGravelListMM,
				...peaGravelListMT,
				...peaGravelListMRL,
				...peaGravelListSBM,
				...peaGravelListSBT,
				...peaGravelListSBRL,
				...peaGravelListLM,
				...peaGravelListLT,
				...peaGravelListLRL,
				...peaGravelListBM,
				...peaGravelListBT,
				...peaGravelListBRL,
				...peaGravelListVWM,
				...peaGravelListVWT,
				...peaGravelListVWRL,
			]);
			setCalicheList([
				...calicheListMM,
				...calicheListMT,
				...calicheListMRL,
				...calicheListSBM,
				...calicheListSBT,
				...calicheListSBRL,
				...calicheListLM,
				...calicheListLT,
				...calicheListLRL,
				...calicheListBM,
				...calicheListBT,
				...calicheListBRL,
				...calicheListVWM,
				...calicheListVWT,
				...calicheListVWRL,
			]);

			setCrushed34List([
				...crushed34ListMM,
				...crushed34ListMT,
				...crushed34ListMRL,
				...crushed34ListSBM,
				...crushed34ListSBT,
				...crushed34ListSBRL,
				...crushed34ListLM,
				...crushed34ListLT,
				...crushed34ListLRL,
				...crushed34ListBM,
				...crushed34ListBT,
				...crushed34ListBRL,
				...crushed34ListVWM,
				...crushed34ListVWT,
				...crushed34ListVWRL,
			]);

			setLimestoneList([
				...limestoneListMM,
				...limestoneListMT,
				...limestoneListMRL,
				...limestoneListSBM,
				...limestoneListSBT,
				...limestoneListSBRL,
				...limestoneListLM,
				...limestoneListLT,
				...limestoneListLRL,
				...limestoneListBM,
				...limestoneListBT,
				...limestoneListBRL,
				...limestoneListVWM,
				...limestoneListVWT,
				...limestoneListVWRL,
			]);

			setLoading(false);
		} catch (err) {
			console.error(err.message);
			return null;
		}
	};

	const updateRecord = async (id) => {
		setLoadingTable(true);
		setLoadingButton(true);
		const url = api + `/logisticstrip/update/jap/${id}`;
		const token = localStorage.getItem("token");
		axios.defaults.headers.common = { Authorization: `Bearer ${token}` };

		try {
			let body = {
				received: true,
				status: "Delivered",
			};
			const { data } = await axios.patch(url, body);
			let index = -1;

			let duration = "0";
			if (data.startedDate && data.receivedDate) {
				var diffMs = new Date(data.receivedDate) - new Date(data.startedDate);
				var diffHrs = Math.floor((diffMs % 86400000) / 3600000); // hours
				var diffMins = Math.round(((diffMs % 86400000) % 3600000) / 60000); // minutes
				duration = `${diffHrs} hours, ${diffMins} minutes`;
			}

			if (data.material === "Sand") {
				index = sandList.findIndex((item) => item.id === id);
				sandList[index].received = true;
				sandList[index].duration = duration;
				sandList[index].receivedDate = `${dayjs(data.receivedDate)
					.toDate()
					.toLocaleDateString()} - ${dayjs(data.receivedDate)
					.toDate()
					.toLocaleTimeString([], { timeStyle: "short" })}`;
				setSandList(sandList);
			} else if (data.material === "Gravel") {
				index = gravelList.findIndex((item) => item.id === id);
				gravelList[index].received = true;
				gravelList[index].duration = duration;
				gravelList[index].receivedDate = `${dayjs(data.receivedDate)
					.toDate()
					.toLocaleDateString()} - ${dayjs(data.receivedDate)
					.toDate()
					.toLocaleTimeString([], { timeStyle: "short" })}`;
				setGravelList(gravelList);
			} else if (data.material === "Pea Gravel") {
				index = peaGravelList.findIndex((item) => item.id === id);
				peaGravelList[index].received = true;
				peaGravelList[index].duration = duration;
				peaGravelList[index].receivedDate = `${dayjs(data.receivedDate)
					.toDate()
					.toLocaleDateString()} - ${dayjs(data.receivedDate)
					.toDate()
					.toLocaleTimeString([], { timeStyle: "short" })}`;
				setPeaGravelList(peaGravelList);
			} else if (data.material === "Caliche") {
				index = calicheList.findIndex((item) => item.id === id);
				calicheList[index].received = true;
				calicheList[index].duration = duration;
				calicheList[index].receivedDate = `${dayjs(data.receivedDate)
					.toDate()
					.toLocaleDateString()} - ${dayjs(data.receivedDate)
					.toDate()
					.toLocaleTimeString([], { timeStyle: "short" })}`;
				setCalicheList(calicheList);
			} else if (data.material === "Crushed 3/4") {
				index = crushed34List.findIndex((item) => item.id === id);
				crushed34List[index].received = true;
				crushed34List[index].duration = duration;
				crushed34List[index].receivedDate = `${dayjs(data.receivedDate)
					.toDate()
					.toLocaleDateString()} - ${dayjs(data.receivedDate)
					.toDate()
					.toLocaleTimeString([], { timeStyle: "short" })}`;
				setCrushed34List(crushed34List);
			} else if (data.material === '1" Limestone') {
				index = limestoneList.findIndex((item) => item.id === id);
				limestoneList[index].received = true;
				limestoneList[index].duration = duration;
				limestoneList[index].receivedDate = `${dayjs(data.receivedDate)
					.toDate()
					.toLocaleDateString()} - ${dayjs(data.receivedDate)
					.toDate()
					.toLocaleTimeString([], { timeStyle: "short" })}`;
				setLimestoneList(limestoneList);
			}
			setLoadingTable(false);
			setLoadingButton(false);
		} catch (err) {
			console.error(err.message);
			return null;
		}
	};

	const updateRecordJobStatus = async (id, status) => {
		const url = api + `/logisticstrip/update/jap/${id}`;
		const token = localStorage.getItem("token");
		axios.defaults.headers.common = { Authorization: `Bearer ${token}` };

		try {
			let body = {
				jobStatus: status,
			};
			await axios.patch(url, body);
		} catch (err) {
			console.error(err.message);
			return null;
		}
	};

	const deleteRecord = async (id) => {
		setLoadingTable(true);
		const url = api + `/logisticstrip/delete/${id}`;
		const token = localStorage.getItem("token");
		axios.defaults.headers.common = { Authorization: `Bearer ${token}` };

		try {
			await axios.delete(url);
			let dateString = `${date.year()}-${date.month() + 1}-${date.date()}`;
			getTripList(dateString, client, mine);
			setLoadingTable(false);
		} catch (err) {
			console.error(err.message);
			return null;
		}
	};

	const onChangeJobStatus = async (value, type, client, mine) => {
		setLoadingTable(true);
		setLoadingButton(true);
		switch (type) {
			case "s":
				if (client === "Mission" && mine === "Mile 4") {
					let mission = sandList.filter(
						(item) => item.client === "Mission" && item.mine === "Mile 4",
					);
					await Promise.all(
						mission.map((item) => updateRecordJobStatus(item.id, value)),
					).then(() => {
						openNotification("success", "Success", "Sand Status Updated");
						const indexDetailed = detailedData[0].findIndex(
							(item) => item.client === "Mission" && item.mine === "Mile 4",
						);
						detailedData[0][indexDetailed].status = value;
						setLoadingTable(false);
						setLoadingButton(false);
					});
				}
				if (client === "Mission" && mine === "Texan") {
					let mission = sandList.filter(
						(item) => item.client === "Mission" && item.mine === "Texan",
					);
					await Promise.all(
						mission.map((item) => updateRecordJobStatus(item.id, value)),
					).then(() => {
						openNotification("success", "Success", "Sand Status Updated");
						const indexDetailed = detailedData[0].findIndex(
							(item) => item.client === "Mission" && item.mine === "Texan",
						);
						detailedData[0][indexDetailed].status = value;
						setLoadingTable(false);
						setLoadingButton(false);
					});
				}
				if (client === "Mission" && mine === "Rojo Limestone") {
					let mission = sandList.filter(
						(item) =>
							item.client === "Mission" && item.mine === "Rojo Limestone",
					);
					await Promise.all(
						mission.map((item) => updateRecordJobStatus(item.id, value)),
					).then(() => {
						openNotification("success", "Success", "Sand Status Updated");
						const indexDetailed = detailedData[0].findIndex(
							(item) =>
								item.client === "Mission" && item.mine === "Rojo Limestone",
						);
						detailedData[0][indexDetailed].status = value;
						setLoadingTable(false);
						setLoadingButton(false);
					});
				}
				if (client === "San Benito" && mine === "Mile 4") {
					let sanBenito = sandList.filter(
						(item) => item.client === "San Benito" && item.mine === "Mile 4",
					);
					await Promise.all(
						sanBenito.map((item) => updateRecordJobStatus(item.id, value)),
					).then(() => {
						openNotification("success", "Success", "Sand Status Updated");
						const indexDetailed = detailedData[0].findIndex(
							(item) => item.client === "San Benito" && item.mine === "Mile 4",
						);
						detailedData[0][indexDetailed].status = value;
						setLoadingTable(false);
						setLoadingButton(false);
					});
				}
				if (client === "San Benito" && mine === "Texan") {
					let sanBenito = sandList.filter(
						(item) => item.client === "San Benito" && item.mine === "Texan",
					);
					await Promise.all(
						sanBenito.map((item) => updateRecordJobStatus(item.id, value)),
					).then(() => {
						openNotification("success", "Success", "Sand Status Updated");
						const indexDetailed = detailedData[0].findIndex(
							(item) => item.client === "San Benito" && item.mine === "Texan",
						);
						detailedData[0][indexDetailed].status = value;
						setLoadingTable(false);
						setLoadingButton(false);
					});
				}
				if (client === "San Benito" && mine === "Rojo Limestone") {
					let sanBenito = sandList.filter(
						(item) =>
							item.client === "San Benito" && item.mine === "Rojo Limestone",
					);
					await Promise.all(
						sanBenito.map((item) => updateRecordJobStatus(item.id, value)),
					).then(() => {
						openNotification("success", "Success", "Sand Status Updated");
						const indexDetailed = detailedData[0].findIndex(
							(item) =>
								item.client === "San Benito" && item.mine === "Rojo Limestone",
						);
						detailedData[0][indexDetailed].status = value;
						setLoadingTable(false);
						setLoadingButton(false);
					});
				}
				if (client === "Laredo" && mine === "Mile 4") {
					let laredo = sandList.filter(
						(item) => item.client === "Laredo" && item.mine === "Mile 4",
					);
					await Promise.all(
						laredo.map((item) => updateRecordJobStatus(item.id, value)),
					).then(() => {
						openNotification("success", "Success", "Sand Status Updated");
						const indexDetailed = detailedData[0].findIndex(
							(item) => item.client === "Laredo" && item.mine === "Mile 4",
						);
						detailedData[0][indexDetailed].status = value;
						setLoadingTable(false);
						setLoadingButton(false);
					});
				}
				if (client === "Laredo" && mine === "Texan") {
					let laredo = sandList.filter(
						(item) => item.client === "Laredo" && item.mine === "Texan",
					);
					await Promise.all(
						laredo.map((item) => updateRecordJobStatus(item.id, value)),
					).then(() => {
						openNotification("success", "Success", "Sand Status Updated");
						const indexDetailed = detailedData[0].findIndex(
							(item) => item.client === "Laredo" && item.mine === "Texan",
						);
						detailedData[0][indexDetailed].status = value;
						setLoadingTable(false);
						setLoadingButton(false);
					});
				}
				if (client === "Laredo" && mine === "Rojo Limestone") {
					let laredo = sandList.filter(
						(item) =>
							item.client === "Laredo" && item.mine === "Rojo Limestone",
					);
					await Promise.all(
						laredo.map((item) => updateRecordJobStatus(item.id, value)),
					).then(() => {
						openNotification("success", "Success", "Sand Status Updated");
						const indexDetailed = detailedData[0].findIndex(
							(item) =>
								item.client === "Laredo" && item.mine === "Rojo Limestone",
						);
						detailedData[0][indexDetailed].status = value;
						setLoadingTable(false);
						setLoadingButton(false);
					});
				}
				if (client === "Brownsville" && mine === "Mile 4") {
					let brownsville = sandList.filter(
						(item) => item.client === "Brownsville" && item.mine === "Mile 4",
					);
					await Promise.all(
						brownsville.map((item) => updateRecordJobStatus(item.id, value)),
					).then(() => {
						openNotification("success", "Success", "Sand Status Updated");
						const indexDetailed = detailedData[0].findIndex(
							(item) => item.client === "Brownsville" && item.mine === "Mile 4",
						);
						detailedData[0][indexDetailed].status = value;
						setLoadingTable(false);
						setLoadingButton(false);
					});
				}
				if (client === "Brownsville" && mine === "Texan") {
					let brownsville = sandList.filter(
						(item) => item.client === "Brownsville" && item.mine === "Texan",
					);
					await Promise.all(
						brownsville.map((item) => updateRecordJobStatus(item.id, value)),
					).then(() => {
						openNotification("success", "Success", "Sand Status Updated");
						const indexDetailed = detailedData[0].findIndex(
							(item) => item.client === "Brownsville" && item.mine === "Texan",
						);
						detailedData[0][indexDetailed].status = value;
						setLoadingTable(false);
						setLoadingButton(false);
					});
				}
				if (client === "Brownsville" && mine === "Rojo Limestone") {
					let brownsville = sandList.filter(
						(item) =>
							item.client === "Brownsville" && item.mine === "Rojo Limestone",
					);
					await Promise.all(
						brownsville.map((item) => updateRecordJobStatus(item.id, value)),
					).then(() => {
						openNotification("success", "Success", "Sand Status Updated");
						const indexDetailed = detailedData[0].findIndex(
							(item) =>
								item.client === "Brownsville" && item.mine === "Rojo Limestone",
						);
						detailedData[0][indexDetailed].status = value;
						setLoadingTable(false);
						setLoadingButton(false);
					});
				}
				if (client === "Valley Wide" && mine === "Mile 4") {
					let valleywide = sandList.filter(
						(item) => item.client === "Valley Wide" && item.mine === "Mile 4",
					);
					await Promise.all(
						valleywide.map((item) => updateRecordJobStatus(item.id, value)),
					).then(() => {
						openNotification("success", "Success", "Sand Status Updated");
						const indexDetailed = detailedData[0].findIndex(
							(item) => item.client === "Valley Wide" && item.mine === "Mile 4",
						);
						detailedData[0][indexDetailed].status = value;
						setLoadingTable(false);
						setLoadingButton(false);
					});
				}
				if (client === "Valley Wide" && mine === "Texan") {
					let valleywide = sandList.filter(
						(item) => item.client === "Valley Wide" && item.mine === "Texan",
					);
					await Promise.all(
						valleywide.map((item) => updateRecordJobStatus(item.id, value)),
					).then(() => {
						openNotification("success", "Success", "Sand Status Updated");
						const indexDetailed = detailedData[0].findIndex(
							(item) => item.client === "Valley Wide" && item.mine === "Texan",
						);
						detailedData[0][indexDetailed].status = value;
						setLoadingTable(false);
						setLoadingButton(false);
					});
				}
				if (client === "Valley Wide" && mine === "Rojo Limestone") {
					let valleywide = sandList.filter(
						(item) =>
							item.client === "Valley Wide" && item.mine === "Rojo Limestone",
					);
					await Promise.all(
						valleywide.map((item) => updateRecordJobStatus(item.id, value)),
					).then(() => {
						openNotification("success", "Success", "Sand Status Updated");
						const indexDetailed = detailedData[0].findIndex(
							(item) =>
								item.client === "Valley Wide" && item.mine === "Rojo Limestone",
						);
						detailedData[0][indexDetailed].status = value;
						setLoadingTable(false);
						setLoadingButton(false);
					});
				}
				break;
			case "g":
				if (client === "Mission" && mine === "Mile 4") {
					let mission = gravelList.filter(
						(item) => item.client === "Mission" && item.mine === "Mile 4",
					);
					await Promise.all(
						mission.map((item) => updateRecordJobStatus(item.id, value)),
					).then(() => {
						openNotification("success", "Success", "Gravel Status Updated");
						const indexDetailed = detailedData[1].findIndex(
							(item) => item.client === "Mission" && item.mine === "Mile 4",
						);
						detailedData[1][indexDetailed].status = value;
						setLoadingTable(false);
						setLoadingButton(false);
					});
				}
				if (client === "Mission" && mine === "Texan") {
					let mission = gravelList.filter(
						(item) => item.client === "Mission" && item.mine === "Texan",
					);
					await Promise.all(
						mission.map((item) => updateRecordJobStatus(item.id, value)),
					).then(() => {
						openNotification("success", "Success", "Gravel Status Updated");
						const indexDetailed = detailedData[1].findIndex(
							(item) => item.client === "Mission" && item.mine === "Texan",
						);
						detailedData[1][indexDetailed].status = value;
						setLoadingTable(false);
						setLoadingButton(false);
					});
				}
				if (client === "Mission" && mine === "Rojo Limestone") {
					let mission = gravelList.filter(
						(item) =>
							item.client === "Mission" && item.mine === "Rojo Limestone",
					);
					await Promise.all(
						mission.map((item) => updateRecordJobStatus(item.id, value)),
					).then(() => {
						openNotification("success", "Success", "Gravel Status Updated");
						const indexDetailed = detailedData[1].findIndex(
							(item) =>
								item.client === "Mission" && item.mine === "Rojo Limestone",
						);
						detailedData[1][indexDetailed].status = value;
						setLoadingTable(false);
						setLoadingButton(false);
					});
				}
				if (client === "San Benito" && mine === "Mile 4") {
					let sanBenito = gravelList.filter(
						(item) => item.client === "San Benito" && item.mine === "Mile 4",
					);
					await Promise.all(
						sanBenito.map((item) => updateRecordJobStatus(item.id, value)),
					).then(() => {
						openNotification("success", "Success", "Gravel Status Updated");
						const indexDetailed = detailedData[1].findIndex(
							(item) => item.client === "San Benito" && item.mine === "Mile 4",
						);
						detailedData[1][indexDetailed].status = value;
						setLoadingTable(false);
						setLoadingButton(false);
					});
				}
				if (client === "San Benito" && mine === "Texan") {
					let sanBenito = gravelList.filter(
						(item) => item.client === "San Benito" && item.mine === "Texan",
					);
					await Promise.all(
						sanBenito.map((item) => updateRecordJobStatus(item.id, value)),
					).then(() => {
						openNotification("success", "Success", "Gravel Status Updated");
						const indexDetailed = detailedData[1].findIndex(
							(item) => item.client === "San Benito" && item.mine === "Texan",
						);
						detailedData[1][indexDetailed].status = value;
						setLoadingTable(false);
						setLoadingButton(false);
					});
				}
				if (client === "San Benito" && mine === "Rojo Limestone") {
					let sanBenito = gravelList.filter(
						(item) =>
							item.client === "San Benito" && item.mine === "Rojo Limestone",
					);
					await Promise.all(
						sanBenito.map((item) => updateRecordJobStatus(item.id, value)),
					).then(() => {
						openNotification("success", "Success", "Gravel Status Updated");
						const indexDetailed = detailedData[1].findIndex(
							(item) =>
								item.client === "San Benito" && item.mine === "Rojo Limestone",
						);
						detailedData[1][indexDetailed].status = value;
						setLoadingTable(false);
						setLoadingButton(false);
					});
				}
				if (client === "Laredo" && mine === "Mile 4") {
					let laredo = gravelList.filter(
						(item) => item.client === "Laredo" && item.mine === "Mile 4",
					);
					await Promise.all(
						laredo.map((item) => updateRecordJobStatus(item.id, value)),
					).then(() => {
						openNotification("success", "Success", "Gravel Status Updated");
						const indexDetailed = detailedData[1].findIndex(
							(item) => item.client === "Laredo" && item.mine === "Mile 4",
						);
						detailedData[1][indexDetailed].status = value;
						setLoadingTable(false);
						setLoadingButton(false);
					});
				}
				if (client === "Laredo" && mine === "Texan") {
					let laredo = gravelList.filter(
						(item) => item.client === "Laredo" && item.mine === "Texan",
					);
					await Promise.all(
						laredo.map((item) => updateRecordJobStatus(item.id, value)),
					).then(() => {
						openNotification("success", "Success", "Gravel Status Updated");
						const indexDetailed = detailedData[1].findIndex(
							(item) => item.client === "Laredo" && item.mine === "Texan",
						);
						detailedData[1][indexDetailed].status = value;
						setLoadingTable(false);
						setLoadingButton(false);
					});
				}
				if (client === "Laredo" && mine === "Rojo Limestone") {
					let laredo = gravelList.filter(
						(item) =>
							item.client === "Laredo" && item.mine === "Rojo Limestone",
					);
					await Promise.all(
						laredo.map((item) => updateRecordJobStatus(item.id, value)),
					).then(() => {
						openNotification("success", "Success", "Gravel Status Updated");
						const indexDetailed = detailedData[1].findIndex(
							(item) =>
								item.client === "Laredo" && item.mine === "Rojo Limestone",
						);
						detailedData[1][indexDetailed].status = value;
						setLoadingTable(false);
						setLoadingButton(false);
					});
				}
				if (client === "Brownsville" && mine === "Mile 4") {
					let brownsville = gravelList.filter(
						(item) => item.client === "Brownsville" && item.mine === "Mile 4",
					);
					await Promise.all(
						brownsville.map((item) => updateRecordJobStatus(item.id, value)),
					).then(() => {
						openNotification("success", "Success", "Gravel Status Updated");
						const indexDetailed = detailedData[1].findIndex(
							(item) => item.client === "Brownsville" && item.mine === "Mile 4",
						);
						detailedData[1][indexDetailed].status = value;
						setLoadingTable(false);
						setLoadingButton(false);
					});
				}
				if (client === "Brownsville" && mine === "Texan") {
					let brownsville = gravelList.filter(
						(item) => item.client === "Brownsville" && item.mine === "Texan",
					);
					await Promise.all(
						brownsville.map((item) => updateRecordJobStatus(item.id, value)),
					).then(() => {
						openNotification("success", "Success", "Gravel Status Updated");
						const indexDetailed = detailedData[1].findIndex(
							(item) => item.client === "Brownsville" && item.mine === "Texan",
						);
						detailedData[1][indexDetailed].status = value;
						setLoadingTable(false);
						setLoadingButton(false);
					});
				}
				if (client === "Brownsville" && mine === "Rojo Limestone") {
					let brownsville = gravelList.filter(
						(item) =>
							item.client === "Brownsville" && item.mine === "Rojo Limestone",
					);
					await Promise.all(
						brownsville.map((item) => updateRecordJobStatus(item.id, value)),
					).then(() => {
						openNotification("success", "Success", "Gravel Status Updated");
						const indexDetailed = detailedData[1].findIndex(
							(item) =>
								item.client === "Brownsville" && item.mine === "Rojo Limestone",
						);
						detailedData[1][indexDetailed].status = value;
						setLoadingTable(false);
						setLoadingButton(false);
					});
				}
				if (client === "Valley Wide" && mine === "Mile 4") {
					let valleywide = gravelList.filter(
						(item) => item.client === "Valley Wide" && item.mine === "Mile 4",
					);
					await Promise.all(
						valleywide.map((item) => updateRecordJobStatus(item.id, value)),
					).then(() => {
						openNotification("success", "Success", "Gravel Status Updated");
						const indexDetailed = detailedData[1].findIndex(
							(item) => item.client === "Valley Wide" && item.mine === "Mile 4",
						);
						detailedData[1][indexDetailed].status = value;
						setLoadingTable(false);
						setLoadingButton(false);
					});
				}
				if (client === "Valley Wide" && mine === "Texan") {
					let valleywide = gravelList.filter(
						(item) => item.client === "Valley Wide" && item.mine === "Texan",
					);
					await Promise.all(
						valleywide.map((item) => updateRecordJobStatus(item.id, value)),
					).then(() => {
						openNotification("success", "Success", "Gravel Status Updated");
						const indexDetailed = detailedData[1].findIndex(
							(item) => item.client === "Valley Wide" && item.mine === "Texan",
						);
						detailedData[1][indexDetailed].status = value;
						setLoadingTable(false);
						setLoadingButton(false);
					});
				}
				if (client === "Valley Wide" && mine === "Rojo Limestone") {
					let valleywide = gravelList.filter(
						(item) =>
							item.client === "Valley Wide" && item.mine === "Rojo Limestone",
					);
					await Promise.all(
						valleywide.map((item) => updateRecordJobStatus(item.id, value)),
					).then(() => {
						openNotification("success", "Success", "Gravel Status Updated");
						const indexDetailed = detailedData[1].findIndex(
							(item) =>
								item.client === "Valley Wide" && item.mine === "Rojo Limestone",
						);
						detailedData[1][indexDetailed].status = value;
						setLoadingTable(false);
						setLoadingButton(false);
					});
				}
				break;
			case "pg":
				if (client === "Mission" && mine === "Mile 4") {
					let mission = peaGravelList.filter(
						(item) => item.client === "Mission" && item.mine === "Mile 4",
					);
					await Promise.all(
						mission.map((item) => updateRecordJobStatus(item.id, value)),
					).then(() => {
						openNotification("success", "Success", "Pea Gravel Status Updated");
						const indexDetailed = detailedData[2].findIndex(
							(item) => item.client === "Mission" && item.mine === "Mile 4",
						);
						detailedData[2][indexDetailed].status = value;
						setLoadingTable(false);
						setLoadingButton(false);
					});
				}
				if (client === "Mission" && mine === "Texan") {
					let mission = peaGravelList.filter(
						(item) => item.client === "Mission" && item.mine === "Texan",
					);
					await Promise.all(
						mission.map((item) => updateRecordJobStatus(item.id, value)),
					).then(() => {
						openNotification("success", "Success", "Pea Gravel Status Updated");
						const indexDetailed = detailedData[2].findIndex(
							(item) => item.client === "Mission" && item.mine === "Texan",
						);
						detailedData[2][indexDetailed].status = value;
						setLoadingTable(false);
						setLoadingButton(false);
					});
				}
				if (client === "Mission" && mine === "Rojo Limestone") {
					let mission = peaGravelList.filter(
						(item) =>
							item.client === "Mission" && item.mine === "Rojo Limestone",
					);
					await Promise.all(
						mission.map((item) => updateRecordJobStatus(item.id, value)),
					).then(() => {
						openNotification("success", "Success", "Pea Gravel Status Updated");
						const indexDetailed = detailedData[2].findIndex(
							(item) =>
								item.client === "Mission" && item.mine === "Rojo Limestone",
						);
						detailedData[2][indexDetailed].status = value;
						setLoadingTable(false);
						setLoadingButton(false);
					});
				}
				if (client === "San Benito" && mine === "Mile 4") {
					let sanBenito = peaGravelList.filter(
						(item) => item.client === "San Benito" && item.mine === "Mile 4",
					);
					await Promise.all(
						sanBenito.map((item) => updateRecordJobStatus(item.id, value)),
					).then(() => {
						openNotification("success", "Success", "Pea Gravel Status Updated");
						const indexDetailed = detailedData[2].findIndex(
							(item) => item.client === "San Benito" && item.mine === "Mile 4",
						);
						detailedData[2][indexDetailed].status = value;
						setLoadingTable(false);
						setLoadingButton(false);
					});
				}
				if (client === "San Benito" && mine === "Texan") {
					let sanBenito = peaGravelList.filter(
						(item) => item.client === "San Benito" && item.mine === "Texan",
					);
					await Promise.all(
						sanBenito.map((item) => updateRecordJobStatus(item.id, value)),
					).then(() => {
						openNotification("success", "Success", "Pea Gravel Status Updated");
						const indexDetailed = detailedData[2].findIndex(
							(item) => item.client === "San Benito" && item.mine === "Texan",
						);
						detailedData[2][indexDetailed].status = value;
						setLoadingTable(false);
						setLoadingButton(false);
					});
				}
				if (client === "San Benito" && mine === "Rojo Limestone") {
					let sanBenito = peaGravelList.filter(
						(item) =>
							item.client === "San Benito" && item.mine === "Rojo Limestone",
					);
					await Promise.all(
						sanBenito.map((item) => updateRecordJobStatus(item.id, value)),
					).then(() => {
						openNotification("success", "Success", "Pea Gravel Status Updated");
						const indexDetailed = detailedData[2].findIndex(
							(item) =>
								item.client === "San Benito" && item.mine === "Rojo Limestone",
						);
						detailedData[2][indexDetailed].status = value;
						setLoadingTable(false);
						setLoadingButton(false);
					});
				}
				if (client === "Laredo" && mine === "Mile 4") {
					let laredo = peaGravelList.filter(
						(item) => item.client === "Laredo" && item.mine === "Mile 4",
					);
					await Promise.all(
						laredo.map((item) => updateRecordJobStatus(item.id, value)),
					).then(() => {
						openNotification("success", "Success", "Pea Gravel Status Updated");
						const indexDetailed = detailedData[2].findIndex(
							(item) => item.client === "Laredo" && item.mine === "Mile 4",
						);
						detailedData[2][indexDetailed].status = value;
						setLoadingTable(false);
						setLoadingButton(false);
					});
				}
				if (client === "Laredo" && mine === "Texan") {
					let laredo = peaGravelList.filter(
						(item) => item.client === "Laredo" && item.mine === "Texan",
					);
					await Promise.all(
						laredo.map((item) => updateRecordJobStatus(item.id, value)),
					).then(() => {
						openNotification("success", "Success", "Pea Gravel Status Updated");
						const indexDetailed = detailedData[2].findIndex(
							(item) => item.client === "Laredo" && item.mine === "Texan",
						);
						detailedData[2][indexDetailed].status = value;
						setLoadingTable(false);
						setLoadingButton(false);
					});
				}
				if (client === "Laredo" && mine === "Rojo Limestone") {
					let laredo = peaGravelList.filter(
						(item) =>
							item.client === "Laredo" && item.mine === "Rojo Limestone",
					);
					await Promise.all(
						laredo.map((item) => updateRecordJobStatus(item.id, value)),
					).then(() => {
						openNotification("success", "Success", "Pea Gravel Status Updated");
						const indexDetailed = detailedData[2].findIndex(
							(item) =>
								item.client === "Laredo" && item.mine === "Rojo Limestone",
						);
						detailedData[2][indexDetailed].status = value;
						setLoadingTable(false);
						setLoadingButton(false);
					});
				}
				if (client === "Brownsville" && mine === "Mile 4") {
					let brownsville = peaGravelList.filter(
						(item) => item.client === "Brownsville" && item.mine === "Mile 4",
					);
					await Promise.all(
						brownsville.map((item) => updateRecordJobStatus(item.id, value)),
					).then(() => {
						openNotification("success", "Success", "Pea Gravel Status Updated");
						const indexDetailed = detailedData[2].findIndex(
							(item) => item.client === "Brownsville" && item.mine === "Mile 4",
						);
						detailedData[2][indexDetailed].status = value;
						setLoadingTable(false);
						setLoadingButton(false);
					});
				}
				if (client === "Brownsville" && mine === "Texan") {
					let brownsville = peaGravelList.filter(
						(item) => item.client === "Brownsville" && item.mine === "Texan",
					);
					await Promise.all(
						brownsville.map((item) => updateRecordJobStatus(item.id, value)),
					).then(() => {
						openNotification("success", "Success", "Pea Gravel Status Updated");
						const indexDetailed = detailedData[2].findIndex(
							(item) => item.client === "Brownsville" && item.mine === "Texan",
						);
						detailedData[2][indexDetailed].status = value;
						setLoadingTable(false);
						setLoadingButton(false);
					});
				}
				if (client === "Brownsville" && mine === "Rojo Limestone") {
					let brownsville = peaGravelList.filter(
						(item) =>
							item.client === "Brownsville" && item.mine === "Rojo Limestone",
					);
					await Promise.all(
						brownsville.map((item) => updateRecordJobStatus(item.id, value)),
					).then(() => {
						openNotification("success", "Success", "Pea Gravel Status Updated");
						const indexDetailed = detailedData[2].findIndex(
							(item) =>
								item.client === "Brownsville" && item.mine === "Rojo Limestone",
						);
						detailedData[2][indexDetailed].status = value;
						setLoadingTable(false);
						setLoadingButton(false);
					});
				}
				if (client === "Valley Wide" && mine === "Mile 4") {
					let valleywide = peaGravelList.filter(
						(item) => item.client === "Valley Wide" && item.mine === "Mile 4",
					);
					await Promise.all(
						valleywide.map((item) => updateRecordJobStatus(item.id, value)),
					).then(() => {
						openNotification("success", "Success", "Pea Gravel Status Updated");
						const indexDetailed = detailedData[2].findIndex(
							(item) => item.client === "Valley Wide" && item.mine === "Mile 4",
						);
						detailedData[2][indexDetailed].status = value;
						setLoadingTable(false);
						setLoadingButton(false);
					});
				}
				if (client === "Valley Wide" && mine === "Texan") {
					let valleywide = peaGravelList.filter(
						(item) => item.client === "Valley Wide" && item.mine === "Texan",
					);
					await Promise.all(
						valleywide.map((item) => updateRecordJobStatus(item.id, value)),
					).then(() => {
						openNotification("success", "Success", "Pea Gravel Status Updated");
						const indexDetailed = detailedData[2].findIndex(
							(item) => item.client === "Valley Wide" && item.mine === "Texan",
						);
						detailedData[2][indexDetailed].status = value;
						setLoadingTable(false);
						setLoadingButton(false);
					});
				}
				if (client === "Valley Wide" && mine === "Rojo Limestone") {
					let valleywide = peaGravelList.filter(
						(item) =>
							item.client === "Valley Wide" && item.mine === "Rojo Limestone",
					);
					await Promise.all(
						valleywide.map((item) => updateRecordJobStatus(item.id, value)),
					).then(() => {
						openNotification("success", "Success", "Pea Gravel Status Updated");
						const indexDetailed = detailedData[2].findIndex(
							(item) =>
								item.client === "Valley Wide" && item.mine === "Rojo Limestone",
						);
						detailedData[2][indexDetailed].status = value;
						setLoadingTable(false);
						setLoadingButton(false);
					});
				}
				break;
			case "c":
				if (client === "Mission" && mine === "Mile 4") {
					let mission = calicheList.filter(
						(item) => item.client === "Mission" && item.mine === "Mile 4",
					);
					await Promise.all(
						mission.map((item) => updateRecordJobStatus(item.id, value)),
					).then(() => {
						openNotification("success", "Success", "Caliche Status Updated");
						const indexDetailed = detailedData[3].findIndex(
							(item) => item.client === "Mission" && item.mine === "Mile 4",
						);
						detailedData[3][indexDetailed].status = value;
						setLoadingTable(false);
						setLoadingButton(false);
					});
				}
				if (client === "Mission" && mine === "Texan") {
					let mission = calicheList.filter(
						(item) => item.client === "Mission" && item.mine === "Texan",
					);
					await Promise.all(
						mission.map((item) => updateRecordJobStatus(item.id, value)),
					).then(() => {
						openNotification("success", "Success", "Caliche Status Updated");
						const indexDetailed = detailedData[3].findIndex(
							(item) => item.client === "Mission" && item.mine === "Texan",
						);
						detailedData[3][indexDetailed].status = value;
						setLoadingTable(false);
						setLoadingButton(false);
					});
				}
				if (client === "Mission" && mine === "Rojo Limestone") {
					let mission = calicheList.filter(
						(item) =>
							item.client === "Mission" && item.mine === "Rojo Limestone",
					);
					await Promise.all(
						mission.map((item) => updateRecordJobStatus(item.id, value)),
					).then(() => {
						openNotification("success", "Success", "Caliche Status Updated");
						const indexDetailed = detailedData[3].findIndex(
							(item) =>
								item.client === "Mission" && item.mine === "Rojo Limestone",
						);
						detailedData[3][indexDetailed].status = value;
						setLoadingTable(false);
						setLoadingButton(false);
					});
				}
				if (client === "San Benito" && mine === "Mile 4") {
					let sanBenito = calicheList.filter(
						(item) => item.client === "San Benito" && item.mine === "Mile 4",
					);
					await Promise.all(
						sanBenito.map((item) => updateRecordJobStatus(item.id, value)),
					).then(() => {
						openNotification("success", "Success", "Caliche Status Updated");
						const indexDetailed = detailedData[3].findIndex(
							(item) => item.client === "San Benito" && item.mine === "Mile 4",
						);
						detailedData[3][indexDetailed].status = value;
						setLoadingTable(false);
						setLoadingButton(false);
					});
				}
				if (client === "San Benito" && mine === "Texan") {
					let sanBenito = calicheList.filter(
						(item) => item.client === "San Benito" && item.mine === "Texan",
					);
					await Promise.all(
						sanBenito.map((item) => updateRecordJobStatus(item.id, value)),
					).then(() => {
						openNotification("success", "Success", "Caliche Status Updated");
						const indexDetailed = detailedData[3].findIndex(
							(item) => item.client === "San Benito" && item.mine === "Texan",
						);
						detailedData[3][indexDetailed].status = value;
						setLoadingTable(false);
						setLoadingButton(false);
					});
				}
				if (client === "San Benito" && mine === "Rojo Limestone") {
					let sanBenito = calicheList.filter(
						(item) =>
							item.client === "San Benito" && item.mine === "Rojo Limestone",
					);
					await Promise.all(
						sanBenito.map((item) => updateRecordJobStatus(item.id, value)),
					).then(() => {
						openNotification("success", "Success", "Caliche Status Updated");
						const indexDetailed = detailedData[3].findIndex(
							(item) =>
								item.client === "San Benito" && item.mine === "Rojo Limestone",
						);
						detailedData[3][indexDetailed].status = value;
						setLoadingTable(false);
						setLoadingButton(false);
					});
				}
				if (client === "Laredo" && mine === "Mile 4") {
					let laredo = calicheList.filter(
						(item) => item.client === "Laredo" && item.mine === "Mile 4",
					);
					await Promise.all(
						laredo.map((item) => updateRecordJobStatus(item.id, value)),
					).then(() => {
						openNotification("success", "Success", "Caliche Status Updated");
						const indexDetailed = detailedData[3].findIndex(
							(item) => item.client === "Laredo" && item.mine === "Mile 4",
						);
						detailedData[3][indexDetailed].status = value;
						setLoadingTable(false);
						setLoadingButton(false);
					});
				}
				if (client === "Laredo" && mine === "Texan") {
					let laredo = calicheList.filter(
						(item) => item.client === "Laredo" && item.mine === "Texan",
					);
					await Promise.all(
						laredo.map((item) => updateRecordJobStatus(item.id, value)),
					).then(() => {
						openNotification("success", "Success", "Caliche Status Updated");
						const indexDetailed = detailedData[3].findIndex(
							(item) => item.client === "Laredo" && item.mine === "Texan",
						);
						detailedData[3][indexDetailed].status = value;
						setLoadingTable(false);
						setLoadingButton(false);
					});
				}
				if (client === "Laredo" && mine === "Rojo Limestone") {
					let laredo = calicheList.filter(
						(item) =>
							item.client === "Laredo" && item.mine === "Rojo Limestone",
					);
					await Promise.all(
						laredo.map((item) => updateRecordJobStatus(item.id, value)),
					).then(() => {
						openNotification("success", "Success", "Caliche Status Updated");
						const indexDetailed = detailedData[3].findIndex(
							(item) =>
								item.client === "Laredo" && item.mine === "Rojo Limestone",
						);
						detailedData[3][indexDetailed].status = value;
						setLoadingTable(false);
						setLoadingButton(false);
					});
				}
				if (client === "Brownsville" && mine === "Mile 4") {
					let brownsville = calicheList.filter(
						(item) => item.client === "Brownsville" && item.mine === "Mile 4",
					);
					await Promise.all(
						brownsville.map((item) => updateRecordJobStatus(item.id, value)),
					).then(() => {
						openNotification("success", "Success", "Caliche Status Updated");
						const indexDetailed = detailedData[3].findIndex(
							(item) => item.client === "Brownsville" && item.mine === "Mile 4",
						);
						detailedData[3][indexDetailed].status = value;
						setLoadingTable(false);
						setLoadingButton(false);
					});
				}
				if (client === "Brownsville" && mine === "Texan") {
					let brownsville = calicheList.filter(
						(item) => item.client === "Brownsville" && item.mine === "Texan",
					);
					await Promise.all(
						brownsville.map((item) => updateRecordJobStatus(item.id, value)),
					).then(() => {
						openNotification("success", "Success", "Caliche Status Updated");
						const indexDetailed = detailedData[3].findIndex(
							(item) => item.client === "Brownsville" && item.mine === "Texan",
						);
						detailedData[3][indexDetailed].status = value;
						setLoadingTable(false);
						setLoadingButton(false);
					});
				}
				if (client === "Brownsville" && mine === "Rojo Limestone") {
					let brownsville = calicheList.filter(
						(item) =>
							item.client === "Brownsville" && item.mine === "Rojo Limestone",
					);
					await Promise.all(
						brownsville.map((item) => updateRecordJobStatus(item.id, value)),
					).then(() => {
						openNotification("success", "Success", "Caliche Status Updated");
						const indexDetailed = detailedData[3].findIndex(
							(item) =>
								item.client === "Brownsville" && item.mine === "Rojo Limestone",
						);
						detailedData[3][indexDetailed].status = value;
						setLoadingTable(false);
						setLoadingButton(false);
					});
				}
				if (client === "Valley Wide" && mine === "Mile 4") {
					let valleywide = calicheList.filter(
						(item) => item.client === "Valley Wide" && item.mine === "Mile 4",
					);
					await Promise.all(
						valleywide.map((item) => updateRecordJobStatus(item.id, value)),
					).then(() => {
						openNotification("success", "Success", "Caliche Status Updated");
						const indexDetailed = detailedData[3].findIndex(
							(item) => item.client === "Valley Wide" && item.mine === "Mile 4",
						);
						detailedData[3][indexDetailed].status = value;
						setLoadingTable(false);
						setLoadingButton(false);
					});
				}
				if (client === "Valley Wide" && mine === "Texan") {
					let valleywide = calicheList.filter(
						(item) => item.client === "Valley Wide" && item.mine === "Texan",
					);
					await Promise.all(
						valleywide.map((item) => updateRecordJobStatus(item.id, value)),
					).then(() => {
						openNotification("success", "Success", "Caliche Status Updated");
						const indexDetailed = detailedData[3].findIndex(
							(item) => item.client === "Valley Wide" && item.mine === "Texan",
						);
						detailedData[3][indexDetailed].status = value;
						setLoadingTable(false);
						setLoadingButton(false);
					});
				}
				if (client === "Valley Wide" && mine === "Rojo Limestone") {
					let valleywide = calicheList.filter(
						(item) =>
							item.client === "Valley Wide" && item.mine === "Rojo Limestone",
					);
					await Promise.all(
						valleywide.map((item) => updateRecordJobStatus(item.id, value)),
					).then(() => {
						openNotification("success", "Success", "Caliche Status Updated");
						const indexDetailed = detailedData[3].findIndex(
							(item) =>
								item.client === "Valley Wide" && item.mine === "Rojo Limestone",
						);
						detailedData[3][indexDetailed].status = value;
						setLoadingTable(false);
						setLoadingButton(false);
					});
				}
				break;
			case "c34":
				if (client === "Mission" && mine === "Mile 4") {
					let mission = crushed34List.filter(
						(item) => item.client === "Mission" && item.mine === "Mile 4",
					);
					await Promise.all(
						mission.map((item) => updateRecordJobStatus(item.id, value)),
					).then(() => {
						openNotification(
							"success",
							"Success",
							"Crushed 3/4 Status Updated",
						);
						const indexDetailed = detailedData[4].findIndex(
							(item) => item.client === "Mission" && item.mine === "Mile 4",
						);
						detailedData[4][indexDetailed].status = value;
						setLoadingTable(false);
						setLoadingButton(false);
					});
				}
				if (client === "Mission" && mine === "Texan") {
					let mission = crushed34List.filter(
						(item) => item.client === "Mission" && item.mine === "Texan",
					);
					await Promise.all(
						mission.map((item) => updateRecordJobStatus(item.id, value)),
					).then(() => {
						openNotification(
							"success",
							"Success",
							"Crushed 3/4 Status Updated",
						);
						const indexDetailed = detailedData[4].findIndex(
							(item) => item.client === "Mission" && item.mine === "Texan",
						);
						detailedData[4][indexDetailed].status = value;
						setLoadingTable(false);
						setLoadingButton(false);
					});
				}
				if (client === "Mission" && mine === "Rojo Limestone") {
					let mission = crushed34List.filter(
						(item) =>
							item.client === "Mission" && item.mine === "Rojo Limestone",
					);
					await Promise.all(
						mission.map((item) => updateRecordJobStatus(item.id, value)),
					).then(() => {
						openNotification(
							"success",
							"Success",
							"Crushed 3/4 Status Updated",
						);
						const indexDetailed = detailedData[4].findIndex(
							(item) =>
								item.client === "Mission" && item.mine === "Rojo Limestone",
						);
						detailedData[4][indexDetailed].status = value;
						setLoadingTable(false);
						setLoadingButton(false);
					});
				}
				if (client === "San Benito" && mine === "Mile 4") {
					let sanBenito = crushed34List.filter(
						(item) => item.client === "San Benito" && item.mine === "Mile 4",
					);
					await Promise.all(
						sanBenito.map((item) => updateRecordJobStatus(item.id, value)),
					).then(() => {
						openNotification(
							"success",
							"Success",
							"Crushed 3/4 Status Updated",
						);
						const indexDetailed = detailedData[4].findIndex(
							(item) => item.client === "San Benito" && item.mine === "Mile 4",
						);
						detailedData[4][indexDetailed].status = value;
						setLoadingTable(false);
						setLoadingButton(false);
					});
				}
				if (client === "San Benito" && mine === "Texan") {
					let sanBenito = crushed34List.filter(
						(item) => item.client === "San Benito" && item.mine === "Texan",
					);
					await Promise.all(
						sanBenito.map((item) => updateRecordJobStatus(item.id, value)),
					).then(() => {
						openNotification(
							"success",
							"Success",
							"Crushed 3/4 Status Updated",
						);
						const indexDetailed = detailedData[4].findIndex(
							(item) => item.client === "San Benito" && item.mine === "Texan",
						);
						detailedData[4][indexDetailed].status = value;
						setLoadingTable(false);
						setLoadingButton(false);
					});
				}
				if (client === "San Benito" && mine === "Rojo Limestone") {
					let sanBenito = crushed34List.filter(
						(item) =>
							item.client === "San Benito" && item.mine === "Rojo Limestone",
					);
					await Promise.all(
						sanBenito.map((item) => updateRecordJobStatus(item.id, value)),
					).then(() => {
						openNotification(
							"success",
							"Success",
							"Crushed 3/4 Status Updated",
						);
						const indexDetailed = detailedData[4].findIndex(
							(item) =>
								item.client === "San Benito" && item.mine === "Rojo Limestone",
						);
						detailedData[4][indexDetailed].status = value;
						setLoadingTable(false);
						setLoadingButton(false);
					});
				}
				if (client === "Laredo" && mine === "Mile 4") {
					let laredo = crushed34List.filter(
						(item) => item.client === "Laredo" && item.mine === "Mile 4",
					);
					await Promise.all(
						laredo.map((item) => updateRecordJobStatus(item.id, value)),
					).then(() => {
						openNotification(
							"success",
							"Success",
							"Crushed 3/4 Status Updated",
						);
						const indexDetailed = detailedData[4].findIndex(
							(item) => item.client === "Laredo" && item.mine === "Mile 4",
						);
						detailedData[4][indexDetailed].status = value;
						setLoadingTable(false);
						setLoadingButton(false);
					});
				}
				if (client === "Laredo" && mine === "Texan") {
					let laredo = crushed34List.filter(
						(item) => item.client === "Laredo" && item.mine === "Texan",
					);
					await Promise.all(
						laredo.map((item) => updateRecordJobStatus(item.id, value)),
					).then(() => {
						openNotification(
							"success",
							"Success",
							"Crushed 3/4 Status Updated",
						);
						const indexDetailed = detailedData[4].findIndex(
							(item) => item.client === "Laredo" && item.mine === "Texan",
						);
						detailedData[4][indexDetailed].status = value;
						setLoadingTable(false);
						setLoadingButton(false);
					});
				}
				if (client === "Laredo" && mine === "Rojo Limestone") {
					let laredo = crushed34List.filter(
						(item) =>
							item.client === "Laredo" && item.mine === "Rojo Limestone",
					);
					await Promise.all(
						laredo.map((item) => updateRecordJobStatus(item.id, value)),
					).then(() => {
						openNotification(
							"success",
							"Success",
							"Crushed 3/4 Status Updated",
						);
						const indexDetailed = detailedData[4].findIndex(
							(item) =>
								item.client === "Laredo" && item.mine === "Rojo Limestone",
						);
						detailedData[4][indexDetailed].status = value;
						setLoadingTable(false);
						setLoadingButton(false);
					});
				}
				if (client === "Brownsville" && mine === "Mile 4") {
					let brownsville = crushed34List.filter(
						(item) => item.client === "Brownsville" && item.mine === "Mile 4",
					);
					await Promise.all(
						brownsville.map((item) => updateRecordJobStatus(item.id, value)),
					).then(() => {
						openNotification(
							"success",
							"Success",
							"Crushed 3/4 Status Updated",
						);
						const indexDetailed = detailedData[4].findIndex(
							(item) => item.client === "Brownsville" && item.mine === "Mile 4",
						);
						detailedData[4][indexDetailed].status = value;
						setLoadingTable(false);
						setLoadingButton(false);
					});
				}
				if (client === "Brownsville" && mine === "Texan") {
					let brownsville = crushed34List.filter(
						(item) => item.client === "Brownsville" && item.mine === "Texan",
					);
					await Promise.all(
						brownsville.map((item) => updateRecordJobStatus(item.id, value)),
					).then(() => {
						openNotification(
							"success",
							"Success",
							"Crushed 3/4 Status Updated",
						);
						const indexDetailed = detailedData[4].findIndex(
							(item) => item.client === "Brownsville" && item.mine === "Texan",
						);
						detailedData[4][indexDetailed].status = value;
						setLoadingTable(false);
						setLoadingButton(false);
					});
				}
				if (client === "Brownsville" && mine === "Rojo Limestone") {
					let brownsville = crushed34List.filter(
						(item) =>
							item.client === "Brownsville" && item.mine === "Rojo Limestone",
					);
					await Promise.all(
						brownsville.map((item) => updateRecordJobStatus(item.id, value)),
					).then(() => {
						openNotification(
							"success",
							"Success",
							"Crushed 3/4 Status Updated",
						);
						const indexDetailed = detailedData[4].findIndex(
							(item) =>
								item.client === "Brownsville" && item.mine === "Rojo Limestone",
						);
						detailedData[4][indexDetailed].status = value;
						setLoadingTable(false);
						setLoadingButton(false);
					});
				}
				if (client === "Valley Wide" && mine === "Mile 4") {
					let valleywide = crushed34List.filter(
						(item) => item.client === "Valley Wide" && item.mine === "Mile 4",
					);
					await Promise.all(
						valleywide.map((item) => updateRecordJobStatus(item.id, value)),
					).then(() => {
						openNotification(
							"success",
							"Success",
							"Crushed 3/4 Status Updated",
						);
						const indexDetailed = detailedData[4].findIndex(
							(item) => item.client === "Valley Wide" && item.mine === "Mile 4",
						);
						detailedData[4][indexDetailed].status = value;
						setLoadingTable(false);
						setLoadingButton(false);
					});
				}
				if (client === "Valley Wide" && mine === "Texan") {
					let valleywide = crushed34List.filter(
						(item) => item.client === "Valley Wide" && item.mine === "Texan",
					);
					await Promise.all(
						valleywide.map((item) => updateRecordJobStatus(item.id, value)),
					).then(() => {
						openNotification(
							"success",
							"Success",
							"Crushed 3/4 Status Updated",
						);
						const indexDetailed = detailedData[4].findIndex(
							(item) => item.client === "Valley Wide" && item.mine === "Texan",
						);
						detailedData[4][indexDetailed].status = value;
						setLoadingTable(false);
						setLoadingButton(false);
					});
				}
				if (client === "Valley Wide" && mine === "Rojo Limestone") {
					let valleywide = crushed34List.filter(
						(item) =>
							item.client === "Valley Wide" && item.mine === "Rojo Limestone",
					);
					await Promise.all(
						valleywide.map((item) => updateRecordJobStatus(item.id, value)),
					).then(() => {
						openNotification(
							"success",
							"Success",
							"Crushed 3/4 Status Updated",
						);
						const indexDetailed = detailedData[4].findIndex(
							(item) =>
								item.client === "Valley Wide" && item.mine === "Rojo Limestone",
						);
						detailedData[4][indexDetailed].status = value;
						setLoadingTable(false);
						setLoadingButton(false);
					});
				}
				break;
			case "l":
				if (client === "Mission" && mine === "Mile 4") {
					let mission = limestoneList.filter(
						(item) => item.client === "Mission" && item.mine === "Mile 4",
					);
					await Promise.all(
						mission.map((item) => updateRecordJobStatus(item.id, value)),
					).then(() => {
						openNotification(
							"success",
							"Success",
							'1" LimeStone Status Updated',
						);
						const indexDetailed = detailedData[5].findIndex(
							(item) => item.client === "Mission" && item.mine === "Mile 4",
						);
						detailedData[5][indexDetailed].status = value;
						setLoadingTable(false);
						setLoadingButton(false);
					});
				}
				if (client === "Mission" && mine === "Texan") {
					let mission = limestoneList.filter(
						(item) => item.client === "Mission" && item.mine === "Texan",
					);
					await Promise.all(
						mission.map((item) => updateRecordJobStatus(item.id, value)),
					).then(() => {
						openNotification(
							"success",
							"Success",
							'1" LimeStone Status Updated',
						);
						const indexDetailed = detailedData[5].findIndex(
							(item) => item.client === "Mission" && item.mine === "Texan",
						);
						detailedData[5][indexDetailed].status = value;
						setLoadingTable(false);
						setLoadingButton(false);
					});
				}
				if (client === "Mission" && mine === "Rojo Limestone") {
					let mission = limestoneList.filter(
						(item) =>
							item.client === "Mission" && item.mine === "Rojo Limestone",
					);
					await Promise.all(
						mission.map((item) => updateRecordJobStatus(item.id, value)),
					).then(() => {
						openNotification(
							"success",
							"Success",
							'1" LimeStone Status Updated',
						);
						const indexDetailed = detailedData[5].findIndex(
							(item) =>
								item.client === "Mission" && item.mine === "Rojo Limestone",
						);
						detailedData[5][indexDetailed].status = value;
						setLoadingTable(false);
						setLoadingButton(false);
					});
				}
				if (client === "San Benito" && mine === "Mile 4") {
					let sanBenito = limestoneList.filter(
						(item) => item.client === "San Benito" && item.mine === "Mile 4",
					);
					await Promise.all(
						sanBenito.map((item) => updateRecordJobStatus(item.id, value)),
					).then(() => {
						openNotification(
							"success",
							"Success",
							'1" LimeStone Status Updated',
						);
						const indexDetailed = detailedData[5].findIndex(
							(item) => item.client === "San Benito" && item.mine === "Mile 4",
						);
						detailedData[5][indexDetailed].status = value;
						setLoadingTable(false);
						setLoadingButton(false);
					});
				}
				if (client === "San Benito" && mine === "Texan") {
					let sanBenito = limestoneList.filter(
						(item) => item.client === "San Benito" && item.mine === "Texan",
					);
					await Promise.all(
						sanBenito.map((item) => updateRecordJobStatus(item.id, value)),
					).then(() => {
						openNotification(
							"success",
							"Success",
							'1" LimeStone Status Updated',
						);
						const indexDetailed = detailedData[5].findIndex(
							(item) => item.client === "San Benito" && item.mine === "Texan",
						);
						detailedData[5][indexDetailed].status = value;
						setLoadingTable(false);
						setLoadingButton(false);
					});
				}
				if (client === "San Benito" && mine === "Rojo Limestone") {
					let sanBenito = limestoneList.filter(
						(item) =>
							item.client === "San Benito" && item.mine === "Rojo Limestone",
					);
					await Promise.all(
						sanBenito.map((item) => updateRecordJobStatus(item.id, value)),
					).then(() => {
						openNotification(
							"success",
							"Success",
							'1" LimeStone Status Updated',
						);
						const indexDetailed = detailedData[5].findIndex(
							(item) =>
								item.client === "San Benito" && item.mine === "Rojo Limestone",
						);
						detailedData[5][indexDetailed].status = value;
						setLoadingTable(false);
						setLoadingButton(false);
					});
				}
				if (client === "Laredo" && mine === "Mile 4") {
					let laredo = limestoneList.filter(
						(item) => item.client === "Laredo" && item.mine === "Mile 4",
					);
					await Promise.all(
						laredo.map((item) => updateRecordJobStatus(item.id, value)),
					).then(() => {
						openNotification(
							"success",
							"Success",
							'1" LimeStone Status Updated',
						);
						const indexDetailed = detailedData[5].findIndex(
							(item) => item.client === "Laredo" && item.mine === "Mile 4",
						);
						detailedData[5][indexDetailed].status = value;
						setLoadingTable(false);
						setLoadingButton(false);
					});
				}
				if (client === "Laredo" && mine === "Texan") {
					let laredo = limestoneList.filter(
						(item) => item.client === "Laredo" && item.mine === "Texan",
					);
					await Promise.all(
						laredo.map((item) => updateRecordJobStatus(item.id, value)),
					).then(() => {
						openNotification(
							"success",
							"Success",
							'1" LimeStone Status Updated',
						);
						const indexDetailed = detailedData[5].findIndex(
							(item) => item.client === "Laredo" && item.mine === "Texan",
						);
						detailedData[5][indexDetailed].status = value;
						setLoadingTable(false);
						setLoadingButton(false);
					});
				}
				if (client === "Laredo" && mine === "Rojo Limestone") {
					let laredo = limestoneList.filter(
						(item) =>
							item.client === "Laredo" && item.mine === "Rojo Limestone",
					);
					await Promise.all(
						laredo.map((item) => updateRecordJobStatus(item.id, value)),
					).then(() => {
						openNotification(
							"success",
							"Success",
							'1" LimeStone Status Updated',
						);
						const indexDetailed = detailedData[5].findIndex(
							(item) =>
								item.client === "Laredo" && item.mine === "Rojo Limestone",
						);
						detailedData[5][indexDetailed].status = value;
						setLoadingTable(false);
						setLoadingButton(false);
					});
				}
				if (client === "Brownsville" && mine === "Mile 4") {
					let brownsville = limestoneList.filter(
						(item) => item.client === "Brownsville" && item.mine === "Mile 4",
					);
					await Promise.all(
						brownsville.map((item) => updateRecordJobStatus(item.id, value)),
					).then(() => {
						openNotification(
							"success",
							"Success",
							'1" LimeStone Status Updated',
						);
						const indexDetailed = detailedData[5].findIndex(
							(item) => item.client === "Brownsville" && item.mine === "Mile 4",
						);
						detailedData[5][indexDetailed].status = value;
						setLoadingTable(false);
						setLoadingButton(false);
					});
				}
				if (client === "Brownsville" && mine === "Texan") {
					let brownsville = limestoneList.filter(
						(item) => item.client === "Brownsville" && item.mine === "Texan",
					);
					await Promise.all(
						brownsville.map((item) => updateRecordJobStatus(item.id, value)),
					).then(() => {
						openNotification(
							"success",
							"Success",
							'1" LimeStone Status Updated',
						);
						const indexDetailed = detailedData[5].findIndex(
							(item) => item.client === "Brownsville" && item.mine === "Texan",
						);
						detailedData[5][indexDetailed].status = value;
						setLoadingTable(false);
						setLoadingButton(false);
					});
				}
				if (client === "Brownsville" && mine === "Rojo Limestone") {
					let brownsville = limestoneList.filter(
						(item) =>
							item.client === "Brownsville" && item.mine === "Rojo Limestone",
					);
					await Promise.all(
						brownsville.map((item) => updateRecordJobStatus(item.id, value)),
					).then(() => {
						openNotification(
							"success",
							"Success",
							'1" LimeStone Status Updated',
						);
						const indexDetailed = detailedData[5].findIndex(
							(item) =>
								item.client === "Brownsville" && item.mine === "Rojo Limestone",
						);
						detailedData[5][indexDetailed].status = value;
						setLoadingTable(false);
						setLoadingButton(false);
					});
				}
				if (client === "Valley Wide" && mine === "Mile 4") {
					let valleywide = limestoneList.filter(
						(item) => item.client === "Valley Wide" && item.mine === "Mile 4",
					);
					await Promise.all(
						valleywide.map((item) => updateRecordJobStatus(item.id, value)),
					).then(() => {
						openNotification(
							"success",
							"Success",
							'1" LimeStone Status Updated',
						);
						const indexDetailed = detailedData[5].findIndex(
							(item) => item.client === "Valley Wide" && item.mine === "Mile 4",
						);
						detailedData[5][indexDetailed].status = value;
						setLoadingTable(false);
						setLoadingButton(false);
					});
				}
				if (client === "Valley Wide" && mine === "Texan") {
					let valleywide = limestoneList.filter(
						(item) => item.client === "Valley Wide" && item.mine === "Texan",
					);
					await Promise.all(
						valleywide.map((item) => updateRecordJobStatus(item.id, value)),
					).then(() => {
						openNotification(
							"success",
							"Success",
							'1" LimeStone Status Updated',
						);
						const indexDetailed = detailedData[5].findIndex(
							(item) => item.client === "Valley Wide" && item.mine === "Texan",
						);
						detailedData[5][indexDetailed].status = value;
						setLoadingTable(false);
						setLoadingButton(false);
					});
				}
				if (client === "Valley Wide" && mine === "Rojo Limestone") {
					let valleywide = limestoneList.filter(
						(item) =>
							item.client === "Valley Wide" && item.mine === "Rojo Limestone",
					);
					await Promise.all(
						valleywide.map((item) => updateRecordJobStatus(item.id, value)),
					).then(() => {
						openNotification(
							"success",
							"Success",
							'1" LimeStone Status Updated',
						);
						const indexDetailed = detailedData[5].findIndex(
							(item) =>
								item.client === "Valley Wide" && item.mine === "Rojo Limestone",
						);
						detailedData[5][indexDetailed].status = value;
						setLoadingTable(false);
						setLoadingButton(false);
					});
				}
				break;
			default:
				break;
		}
	};

	const copyTickets = (type) => {
		let textContent = "";
		if (type === "sand") {
			sandList.map((i, index) => {
				if (index < sandList.length - 1) {
					textContent += i.ticket + ",";
				} else {
					textContent += i.ticket;
				}
			});
		} else if (type === "gravel") {
			gravelList.map((i, index) => {
				if (index < gravelList.length - 1) {
					textContent += i.ticket + ",";
				} else {
					textContent += i.ticket;
				}
			});
		} else if (type === "peagravel") {
			peaGravelList.map((i, index) => {
				if (index < peaGravelList.length - 1) {
					textContent += i.ticket + ",";
				} else {
					textContent += i.ticket;
				}
			});
		} else if (type === "caliche") {
			calicheList.map((i, index) => {
				if (index < calicheList.length - 1) {
					textContent += i.ticket + ",";
				} else {
					textContent += i.ticket;
				}
			});
		} else if (type === "crushed34") {
			crushed34List.map((i, index) => {
				if (index < crushed34List.length - 1) {
					textContent += i.ticket + ",";
				} else {
					textContent += i.ticket;
				}
			});
		} else if (type === "limestone") {
			limestoneList.map((i, index) => {
				if (index < limestoneList.length - 1) {
					textContent += i.ticket + ",";
				} else {
					textContent += i.ticket;
				}
			});
		}

		navigator.clipboard.writeText(textContent);
	};

	const RenderTables = () => {
		return (
			<Flex gap="medium" justify="center" vertical>
				<Table
					title={() => (
						<>
							<Title level={2}>Sand Orders</Title>
							<Button
								size="large"
								type="primary"
								danger
								onClick={() => copyTickets("sand")}
							>
								Copy Sand Tickets
							</Button>
							{detailedData[0].map((itemSand, index) => {
								return (
									<Row gutter={16}>
										<Col span={3}>
											<Flex vertical>
												<Text strong>ID</Text>
												<Text>{itemSand.id}</Text>
											</Flex>
										</Col>
										<Col span={3}>
											<Flex vertical>
												<Text strong>Quantity</Text>
												<Statistic
													title=""
													value={itemSand.quantity}
													precision={2}
													valueStyle={{ fontSize: 14 }}
												/>{" "}
											</Flex>
										</Col>
										<Col span={3}>
											<Flex vertical>
												<Text strong>Material</Text>
												<Text>{itemSand.material}</Text>
											</Flex>
										</Col>
										<Col span={3}>
											<Flex vertical>
												<Text strong>Client</Text>
												<Text>{itemSand.client}</Text>
											</Flex>
										</Col>
										<Col span={3}>
											<Flex vertical>
												<Text strong>Mine</Text>
												<Text>{itemSand.mine}</Text>
											</Flex>
										</Col>
										<Col span={3}>
											<Flex vertical>
												<Text strong>Status</Text>
												<Select
													options={jobStatusOptions}
													value={itemSand.status}
													onChange={(value) =>
														onChangeJobStatus(
															value,
															"s",
															itemSand.client,
															itemSand.mine,
														)
													}
												/>
											</Flex>
										</Col>
										{index === 0 && (
											<Col span={3}>
												<Flex vertical>
													<Text strong>PDF</Text>
													<Button
														type="primary"
														icon={<FilePdfOutlined twoToneColor={"white"} />}
														onClick={(e) =>
															history.push(
																`/logistics/pdf/${itemSand.material}`,
																{
																	date: date,
																	client: client,
																	mine: mine,
																},
															)
														}
													>
														PDF {itemSand.material}
													</Button>
												</Flex>
											</Col>
										)}
									</Row>
								);
							})}
						</>
					)}
					columns={columns}
					dataSource={sandList}
					pagination={{
						defaultPageSize: 10,
						showSizeChanger: true,
						pageSizeOptions: ["10", "30", "50", "100"],
					}}
					loading={loadingTable}
					onRow={(record, index) => ({
						style: {
							background: record.duplicated
								? "#b9d3fa"
								: !record.evidence && record.received
									? "#fab9b9ff"
									: "white",
						},
					})}
				/>
				<Table
					title={() => (
						<>
							<Title level={2}>Gravel Orders</Title>
							<Button
								size="large"
								type="primary"
								danger
								onClick={() => copyTickets("gravel")}
							>
								Copy Gravel Tickets
							</Button>
							{detailedData[1].map((itemGravel, index) => {
								return (
									<Row gutter={16}>
										<Col span={3}>
											<Flex vertical>
												<Text strong>ID</Text>
												<Text>{itemGravel.id}</Text>
											</Flex>
										</Col>
										<Col span={3}>
											<Flex vertical>
												<Text strong>Quantity</Text>
												<Statistic
													title=""
													value={itemGravel.quantity}
													precision={2}
													valueStyle={{ fontSize: 14 }}
												/>
											</Flex>
										</Col>
										<Col span={3}>
											<Flex vertical>
												<Text strong>Material</Text>
												<Text>{itemGravel.material}</Text>
											</Flex>
										</Col>
										<Col span={3}>
											<Flex vertical>
												<Text strong>Client</Text>
												<Text>{itemGravel.client}</Text>
											</Flex>
										</Col>
										<Col span={3}>
											<Flex vertical>
												<Text strong>Mine</Text>
												<Text>{itemGravel.mine}</Text>
											</Flex>
										</Col>
										<Col span={3}>
											<Flex vertical>
												<Text strong>Status</Text>
												<Select
													options={jobStatusOptions}
													value={itemGravel.status}
													onChange={(value) =>
														onChangeJobStatus(
															value,
															"g",
															itemGravel.client,
															itemGravel.mine,
														)
													}
												/>
											</Flex>
										</Col>
										{index === 0 && (
											<Col span={3}>
												<Flex vertical>
													<Text strong>PDF</Text>
													<Button
														type="primary"
														icon={<FilePdfOutlined twoToneColor={"white"} />}
														onClick={(e) =>
															history.push(
																`/logistics/pdf/${itemGravel.material}`,
																{ date: date, client: client, mine: mine },
															)
														}
													>
														PDF {itemGravel.material}
													</Button>
												</Flex>
											</Col>
										)}
									</Row>
								);
							})}
						</>
					)}
					columns={columns}
					dataSource={gravelList}
					pagination={{
						defaultPageSize: 10,
						showSizeChanger: true,
						pageSizeOptions: ["10", "30", "50", "100"],
					}}
					loading={loadingTable}
					onRow={(record, index) => ({
						style: {
							background: record.duplicated ? "#b9d3fa" : "white",
						},
					})}
				/>
				<Table
					title={() => (
						<>
							<Title level={2}>Pea Gravel Orders</Title>
							<Button
								size="large"
								type="primary"
								danger
								onClick={() => copyTickets("peagravel")}
							>
								Copy Pea Gravel Tickets
							</Button>
							{detailedData[2].map((itemPeaGravel, index) => {
								return (
									<Row gutter={16}>
										<Col span={3}>
											<Flex vertical>
												<Text strong>ID</Text>
												<Text>{itemPeaGravel.id}</Text>
											</Flex>
										</Col>
										<Col span={3}>
											<Flex vertical>
												<Text strong>Quantity</Text>
												<Statistic
													title=""
													value={itemPeaGravel.quantity}
													precision={2}
													valueStyle={{ fontSize: 14 }}
												/>{" "}
											</Flex>
										</Col>
										<Col span={3}>
											<Flex vertical>
												<Text strong>Material</Text>
												<Text>{itemPeaGravel.material}</Text>
											</Flex>
										</Col>
										<Col span={3}>
											<Flex vertical>
												<Text strong>Client</Text>
												<Text>{itemPeaGravel.client}</Text>
											</Flex>
										</Col>
										<Col span={3}>
											<Flex vertical>
												<Text strong>Mine</Text>
												<Text>{itemPeaGravel.mine}</Text>
											</Flex>
										</Col>
										<Col span={3}>
											<Flex vertical>
												<Text strong>Status</Text>
												<Select
													options={jobStatusOptions}
													value={itemPeaGravel.status}
													onChange={(value) =>
														onChangeJobStatus(
															value,
															"pg",
															itemPeaGravel.client,
															itemPeaGravel.mine,
														)
													}
												/>
											</Flex>
										</Col>
										{index === 0 && (
											<Col span={3}>
												<Flex vertical>
													<Text strong>PDF</Text>
													<Button
														type="primary"
														icon={<FilePdfOutlined twoToneColor={"white"} />}
														onClick={(e) =>
															history.push(
																`/logistics/pdf/${itemPeaGravel.material}`,
																{ date: date, client: client, mine: mine },
															)
														}
													>
														PDF {itemPeaGravel.material}
													</Button>
												</Flex>
											</Col>
										)}
									</Row>
								);
							})}
						</>
					)}
					columns={columns}
					dataSource={peaGravelList}
					pagination={{
						defaultPageSize: 10,
						showSizeChanger: true,
						pageSizeOptions: ["10", "30", "50", "100"],
					}}
					loading={loadingTable}
					onRow={(record, index) => ({
						style: {
							background: record.duplicated ? "#b9d3fa" : "white",
						},
					})}
				/>
				<Table
					title={() => (
						<>
							<Title level={2}>Caliche Orders</Title>
							<Button
								size="large"
								type="primary"
								danger
								onClick={() => copyTickets("caliche")}
							>
								Copy Caliche Tickets
							</Button>
							{detailedData[3].map((itemCaliche, index) => {
								return (
									<Row gutter={16}>
										<Col span={3}>
											<Flex vertical>
												<Text strong>ID</Text>
												<Text>{itemCaliche.id}</Text>
											</Flex>
										</Col>
										<Col span={3}>
											<Flex vertical>
												<Text strong>Quantity</Text>
												<Statistic
													title=""
													value={itemCaliche.quantity}
													precision={2}
													valueStyle={{ fontSize: 14 }}
												/>{" "}
											</Flex>
										</Col>
										<Col span={3}>
											<Flex vertical>
												<Text strong>Material</Text>
												<Text>{itemCaliche.material}</Text>
											</Flex>
										</Col>
										<Col span={3}>
											<Flex vertical>
												<Text strong>Client</Text>
												<Text>{itemCaliche.client}</Text>
											</Flex>
										</Col>
										<Col span={3}>
											<Flex vertical>
												<Text strong>Mine</Text>
												<Text>{itemCaliche.mine}</Text>
											</Flex>
										</Col>
										<Col span={3}>
											<Flex vertical>
												<Text strong>Status</Text>
												<Select
													options={jobStatusOptions}
													value={itemCaliche.status}
													onChange={(value) =>
														onChangeJobStatus(
															value,
															"c",
															itemCaliche.client,
															itemCaliche.mine,
														)
													}
												/>
											</Flex>
										</Col>
										{index === 0 && (
											<Col span={3}>
												<Flex vertical>
													<Text strong>PDF</Text>
													<Button
														type="primary"
														icon={<FilePdfOutlined twoToneColor={"white"} />}
														onClick={(e) =>
															history.push(
																`/logistics/pdf/${itemCaliche.material}`,
																{ date: date, client: client, mine: mine },
															)
														}
													>
														PDF {itemCaliche.material}
													</Button>
												</Flex>
											</Col>
										)}
									</Row>
								);
							})}
						</>
					)}
					columns={columns}
					dataSource={calicheList}
					pagination={{
						defaultPageSize: 10,
						showSizeChanger: true,
						pageSizeOptions: ["10", "30", "50", "100"],
					}}
					loading={loadingTable}
					onRow={(record, index) => ({
						style: {
							background: record.duplicated ? "#b9d3fa" : "white",
						},
					})}
				/>
				<Table
					title={() => (
						<>
							<Title level={2}>Crushed 3/4 Orders</Title>
							<Button
								size="large"
								type="primary"
								danger
								onClick={() => copyTickets("crushed34")}
							>
								Copy Crushed 3/4 Tickets
							</Button>
							{detailedData[4].map((itemCrushed34, index) => {
								return (
									<Row gutter={16}>
										<Col span={3}>
											<Flex vertical>
												<Text strong>ID</Text>
												<Text>{itemCrushed34.id}</Text>
											</Flex>
										</Col>
										<Col span={3}>
											<Flex vertical>
												<Text strong>Quantity</Text>
												<Statistic
													title=""
													value={itemCrushed34.quantity}
													precision={2}
													valueStyle={{ fontSize: 14 }}
												/>{" "}
											</Flex>
										</Col>
										<Col span={3}>
											<Flex vertical>
												<Text strong>Material</Text>
												<Text>{itemCrushed34.material}</Text>
											</Flex>
										</Col>
										<Col span={3}>
											<Flex vertical>
												<Text strong>Client</Text>
												<Text>{itemCrushed34.client}</Text>
											</Flex>
										</Col>
										<Col span={3}>
											<Flex vertical>
												<Text strong>Mine</Text>
												<Text>{itemCrushed34.mine}</Text>
											</Flex>
										</Col>
										<Col span={3}>
											<Flex vertical>
												<Text strong>Status</Text>
												<Select
													options={jobStatusOptions}
													value={itemCrushed34.status}
													onChange={(value) =>
														onChangeJobStatus(
															value,
															"c34",
															itemCrushed34.client,
															itemCrushed34.mine,
														)
													}
												/>
											</Flex>
										</Col>
										{index === 0 && (
											<Col span={3}>
												<Flex vertical>
													<Text strong>PDF</Text>
													<Button
														type="primary"
														icon={<FilePdfOutlined twoToneColor={"white"} />}
														onClick={(e) =>
															history.push(
																`/logistics/pdf/${itemCrushed34.material}`,
																{ date: date, client: client, mine: mine },
															)
														}
													>
														PDF {itemCrushed34.material}
													</Button>
												</Flex>
											</Col>
										)}
									</Row>
								);
							})}
						</>
					)}
					columns={columns}
					dataSource={crushed34List}
					pagination={{
						defaultPageSize: 10,
						showSizeChanger: true,
						pageSizeOptions: ["10", "30", "50", "100"],
					}}
					loading={loadingTable}
					onRow={(record, index) => ({
						style: {
							background: record.duplicated ? "#b9d3fa" : "white",
						},
					})}
				/>
				<Table
					title={() => (
						<>
							<Title level={2}>1" Limestone Orders</Title>
							<Button
								size="large"
								type="primary"
								danger
								onClick={() => copyTickets("limestone")}
							>
								Copy 1" Limestone Tickets
							</Button>
							{detailedData[5].map((itemLimestone, index) => {
								return (
									<Row gutter={16}>
										<Col span={3}>
											<Flex vertical>
												<Text strong>ID</Text>
												<Text>{itemLimestone.id}</Text>
											</Flex>
										</Col>
										<Col span={3}>
											<Flex vertical>
												<Text strong>Quantity</Text>
												<Statistic
													title=""
													value={itemLimestone.quantity}
													precision={2}
													valueStyle={{ fontSize: 14 }}
												/>{" "}
											</Flex>
										</Col>
										<Col span={3}>
											<Flex vertical>
												<Text strong>Material</Text>
												<Text>{itemLimestone.material}</Text>
											</Flex>
										</Col>
										<Col span={3}>
											<Flex vertical>
												<Text strong>Client</Text>
												<Text>{itemLimestone.client}</Text>
											</Flex>
										</Col>
										<Col span={3}>
											<Flex vertical>
												<Text strong>Mine</Text>
												<Text>{itemLimestone.mine}</Text>
											</Flex>
										</Col>
										<Col span={3}>
											<Flex vertical>
												<Text strong>Status</Text>
												<Select
													options={jobStatusOptions}
													value={itemLimestone.status}
													onChange={(value) =>
														onChangeJobStatus(
															value,
															"l",
															itemLimestone.client,
															itemLimestone.mine,
														)
													}
												/>
											</Flex>
										</Col>
										{index === 0 && (
											<Col span={3}>
												<Flex vertical>
													<Text strong>PDF</Text>
													<Button
														type="primary"
														icon={<FilePdfOutlined twoToneColor={"white"} />}
														onClick={(e) =>
															history.push(
																`/logistics/pdf/${itemLimestone.material}`,
																{ date: date, client: client, mine: mine },
															)
														}
													>
														PDF {itemLimestone.material}
													</Button>
												</Flex>
											</Col>
										)}
									</Row>
								);
							})}
						</>
					)}
					columns={columns}
					dataSource={limestoneList}
					pagination={{
						defaultPageSize: 10,
						showSizeChanger: true,
						pageSizeOptions: ["10", "30", "50", "100"],
					}}
					loading={loadingTable}
					onRow={(record, index) => ({
						style: {
							background: record.duplicated ? "#b9d3fa" : "white",
						},
					})}
				/>
			</Flex>
		);
	};

	const onChangeDate = (date) => {
		let dateString = `${date.year()}-${date.month() + 1}-${date.date()}`;
		getTripList(dateString, client, mine);
		setDate(date);
	};

	const handleEvidenceCancel = () => {
		setLoadingButton(false);
		setOpenEvidenceModal(false);
	};

	const handleEvidenceOpen = (evidence) => {
		setLoadingButton(true);
		setEvidence(evidence);
		setOpenEvidenceModal(true);
	};

	const RenderEvidence = () => {
		return (
			<Modal
				title="Evidence Image"
				open={openEvidenceModal}
				onCancel={handleEvidenceCancel}
				cancelButtonProps={{ style: { display: "none" } }}
				okButtonProps={{ style: { display: "none" } }}
			>
				<Flex align="center" justify="center">
					<Image id="evidence" width={300} src={evidence} />
				</Flex>
			</Modal>
		);
	};

	const onChangeClient = (value) => {
		if (value) {
			let dateString = `${date.year()}-${date.month() + 1}-${date.date()}`;
			getTripList(dateString, value, mine);
			setClient(value);
		}
	};

	const onChangeMine = (value) => {
		if (value) {
			let dateString = `${date.year()}-${date.month() + 1}-${date.date()}`;
			getTripList(dateString, client, value);
			setMine(value);
		}
	};

	const filterOption = (input, option) =>
		(option?.label ?? "").toLowerCase().includes(input.toLowerCase());

	const RenderDate = () => {
		return (
			<Flex gap={"middle"}>
				<DatePicker
					value={date}
					format={"MM/DD/YYYY"}
					onChange={onChangeDate}
					size="large"
					allowClear={false}
					style={{ width: 200 }}
				/>
				<Select
					showSearch
					placeholder={`Select client`}
					optionFilterProp="children"
					size="large"
					onChange={onChangeClient}
					filterOption={filterOption}
					options={clients}
					disabled={loading}
					value={client}
					style={{
						width: "200px",
					}}
				/>
				<Select
					showSearch
					placeholder={`Select mine`}
					optionFilterProp="children"
					size="large"
					onChange={onChangeMine}
					filterOption={filterOption}
					options={mines}
					disabled={loading}
					value={mine}
					style={{
						width: "200px",
					}}
				/>
			</Flex>
		);
	};

	const RenderButton = () => {
		return (
			<Row gutter={16}>
				{(localStorage.getItem("email") === "eliud@gmail.com" ||
					localStorage.getItem("email") === "ec@nextgsys.com" ||
					localStorage.getItem("email") === "pc@57concrete.com" ||
					localStorage.getItem("email") === "jc@57concrete.com" ||
					localStorage.getItem("email") === "gg@57xgroup.com" ||
					localStorage.getItem("email") === "reyesss22@icloud.com" ||
					localStorage.getItem("email") === "scale@filegonia.com") && (
					<Col span={24} xs={12} md={6} xl={4}>
						<Button
							size="large"
							type="primary"
							htmlType="button"
							style={{ width: "100%" }}
							loading={loading}
							onClick={() => history.push("/logisticstrip/new")}
						>
							New Trip
						</Button>
					</Col>
				)}
				<Col span={24} xs={12} md={6} xl={4}>
					<Button
						size="large"
						type="primary"
						htmlType="button"
						style={{ width: "100%" }}
						loading={loading}
						onClick={() => history.push("/reports/logistics/detailed")}
					>
						Detailed Report
					</Button>
				</Col>
				<Col span={24} xs={12} md={8} xl={6}>
					<Button
						type="primary"
						style={{ width: "100%" }}
						onClick={(e) => refDownload.current.link.click()}
						loading={loading}
						size="large"
					>
						Download Today Detailed Report
					</Button>
					<CSVLink
						data={dataExport}
						headers={columnsCSV}
						filename={"57concrete-logistics-detailed-today.csv"}
						hidden
						ref={refDownload}
					>
						Download report
					</CSVLink>
				</Col>
			</Row>
		);
	};

	return (
		<Layout title="Logistics Dashboard" description="Dashboard">
			<Flex vertical gap={"small"}>
				<RenderDate />
				<RenderButton />
				{loading ? <CustomSpinner /> : <RenderTables />}
			</Flex>
			<RenderEvidence />
			{contextHolder}
		</Layout>
	);
};

export default WebLogisticsDashboard;
